/* LE_CACHE_BUST_1786443598 */
/* LE_CREDIT_ON_DOWNLOAD_20260803 */
/* LE_MAESTRO_VALIDATE_20260907 */
/* LE_GATE_BG_TRIM_20260907 */
/* LE_ZONES_PREVIEW_20260907 */
/* LE_MAESTRO_FILL_20260907 */
/* LE_QUALITY_SPINNER_20260907 */
/* LE_DONE_BADGES_20260907 */
/* LE_MAESTRO_STORAGE_20260907 */
/* LE_MAESTRO_INFOS_20260907 */
/* LE_MAESTRO_HTML_500_20260907 */
/* LE_MAESTRO_S3_URL_20260907 */
/* LE_MAESTRO_CLOUD_PNG_20260907c */
/* LE_MAESTRO_OMIT_COOKIES_20260908a */
/* LE_MAESTRO_SAME_ORIGIN_20260908b */
/* LE_MAESTRO_FO_URL_20260908c */
/* LE_MAESTRO_ASCII_FILENAME_20260908d */
/* LE_VECTOR_DPI_20260908e */
/* LE_ZONE_TOGGLES_20260908f */
/* LE_VECTOR_API_PDF_20260911 */
/* LE_VECTOR_PDF_ISOLATE_20260911 */
(() => {
  const initializedEditors = new WeakSet();

  window.LogoEditor = window.LogoEditor || {};
  window.LogoEditor.init = initLogoEditor;
  window.LogoEditor.open = openLogoEditorFromHost;

  bindLogoEditorLaunchers();

  function bindLogoEditorLaunchers() {
    document.querySelectorAll('[data-logo-editor]').forEach((editorRoot) => initLogoEditor(editorRoot));
    document.querySelectorAll('[data-logo-editor-launcher]').forEach((button) => {
      if (button.dataset.logoEditorBound === 'true') return;
      button.dataset.logoEditorBound = 'true';
      button.addEventListener('click', () => openLogoEditor(button));
    });
  }

  function resolveLogoEditorNode(value, fallbackSelector) {
    if (value && typeof value === 'object' && value.nodeType === 1) return value;
    const selector = typeof value === 'string' && value ? value : fallbackSelector;
    return selector ? document.querySelector(selector) : null;
  }

  function clearActiveLogoEditor() {
    document.querySelectorAll('[data-logo-editor]').forEach((node) => node.remove());
    document.body.classList.remove('le-editor-open');
  }

  function openLogoEditorFromHost(options = {}) {
    const template = resolveLogoEditorNode(options.template, '#logo-editor-template-sherpa');
    const mount = resolveLogoEditorNode(options.mount, '#logo-editor-mount-sherpa');
    if (!template || !mount) {
      return Promise.reject(new Error('Éditeur de logo indisponible'));
    }

    clearActiveLogoEditor();
    mount.textContent = '';
    mount.appendChild(template.content.cloneNode(true));
    const editorRoot = mount.querySelector('[data-logo-editor]');
    if (!editorRoot) {
      return Promise.reject(new Error('Éditeur de logo indisponible'));
    }

    const hostLauncher = {
      setAttribute() {},
      focus() {},
      dataset: {},
    };
    editorRoot.__logoEditorLauncher = hostLauncher;
    editorRoot.__logoEditorHost = {
      mode: options.mode === 'apply' ? 'apply' : 'download',
      file: options.file || null,
      fileName: options.fileName || options.file?.name || '',
      printWidthCm: Number(options.printWidthCm) || 0,
      printHeightCm: Number(options.printHeightCm) || 0,
      onApply: typeof options.onApply === 'function' ? options.onApply : null,
      onClose: typeof options.onClose === 'function' ? options.onClose : null,
    };

    document.body.classList.add('le-editor-open');
    initLogoEditor(editorRoot);
    return Promise.resolve(editorRoot);
  }

  function openLogoEditor(button) {
    if (button.dataset.customerLoggedIn !== 'true') {
      redirectLogoEditorLogin(button);
      return;
    }

    const template = document.querySelector(button.dataset.logoEditorTemplate);
    const mount = document.querySelector(button.dataset.logoEditorMount);
    if (!template || !mount) return;

    clearActiveLogoEditor();
    mount.textContent = '';
    mount.appendChild(template.content.cloneNode(true));
    const editorRoot = mount.querySelector('[data-logo-editor]');

    if (!editorRoot) return;
    editorRoot.__logoEditorLauncher = button;
    button.setAttribute('aria-expanded', 'true');
    document.body.classList.add('le-editor-open');
    initLogoEditor(editorRoot);
  }

  function redirectLogoEditorLogin(button) {
    const loginUrl = button.dataset.loginUrl || '/account/login';
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    const separator = loginUrl.includes('?') ? '&' : '?';
    window.location.assign(`${loginUrl}${separator}return_url=${returnUrl}`);
  }

  function initLogoEditor(root) {
    if (!root || initializedEditors.has(root)) return;
    initializedEditors.add(root);
    document.body.classList.add('le-editor-open');

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));

  const refs = {
    fileInput: $('[data-file-input]'),
    dropzone: $('[data-dropzone]'),
    fileSection: $('[data-file-section]'),
    uploadTitle: $('[data-upload-title]'),
    fileState: $('[data-file-state]'),
    fileCard: $('[data-file-card]'),
    fileName: $('[data-file-name]'),
    fileMeta: $('[data-file-meta]'),
    thumbCanvas: $('[data-thumb-canvas]'),
    bgColor: $('[data-bg-color]'),
    bgTolerance: $('[data-bg-tolerance]'),
    bgToleranceLabel: $('[data-bg-tolerance-label]'),
    bgFeather: $('[data-bg-feather]'),
    bgFeatherLabel: $('[data-bg-feather-label]'),
    bgStatus: $('[data-bg-status]'),
    removeGlobal: $('[data-remove-global]'),
    semiThreshold: $('[data-semi-threshold]'),
    semiThresholdLabel: $('[data-semi-threshold-label]'),
    textileColor: $('[data-textile-color]'),
    textileTolerance: $('[data-textile-tolerance]'),
    textileToleranceLabel: $('[data-textile-tolerance-label]'),
    adjustBrightness: $('[data-adjust-brightness]'),
    adjustBrightnessLabel: $('[data-adjust-brightness-label]'),
    adjustContrast: $('[data-adjust-contrast]'),
    adjustContrastLabel: $('[data-adjust-contrast-label]'),
    adjustSaturation: $('[data-adjust-saturation]'),
    adjustSaturationLabel: $('[data-adjust-saturation-label]'),
    cropStatus: $('[data-crop-status]'),
    previewCanvas: $('[data-preview-canvas]'),
    vectorStage: $('[data-vector-stage]'),
    stageStack: $('[data-stage-stack]'),
    stageLoader: $('[data-stage-loader]'),
    stageLoaderTitle: $('[data-stage-loader-title]'),
    stageLoaderDetail: $('[data-stage-loader-detail]'),
    canvasZone: $('[data-canvas-zone]'),
    emptyState: $('[data-empty-state]'),
    statusSize: $('[data-status-size]'),
    statusPrint: $('[data-status-print]'),
    statusColors: $('[data-status-colors]'),
    operationStatus: $('[data-operation-status]'),
    zoomLabel: $('[data-zoom-label]'),
    lockRatio: $('[data-lock-ratio]'),
    resizeWidth: $('[data-resize-width]'),
    resizeHeight: $('[data-resize-height]'),
    resizeScale: $('[data-resize-scale]'),
    resizeScaleLabel: $('[data-resize-scale-label]'),
    dimensionsDpi: $('[data-dimensions-dpi]'),
    upscalePanel: $('[data-upscale-panel]'),
    upscaleFactor: $('[data-upscale-factor]'),
    upscaleEngine: $('[data-upscale-engine]'),
    upscaleStatus: $('[data-upscale-status]'),
    colorTolerance: $('[data-color-tolerance]'),
    colorToleranceLabel: $('[data-color-tolerance-label]'),
    colorList: $('[data-color-list]'),
    colorCount: $('[data-color-count]'),
    colorBulk: $('[data-color-bulk]'),
    bulkColor: $('[data-bulk-color]'),
    vectorColors: $('[data-vector-colors]'),
    vectorDetail: $('[data-vector-detail]'),
    vectorStatus: $('[data-vector-status]'),
    vectorPreview: $('[data-vector-preview]'),
    toastLayer: $('[data-toast-layer]'),
    downloadPdf: $('[data-action="download-pdf"]'),
    saveLibrary: $('[data-action="save-library"]'),
    creditPill: $('[data-credit-pill]'),
    creditLabel: $('[data-credit-label]'),
    creditCount: $('[data-credit-count]'),
    creditModal: $('[data-credit-modal]'),
    creditModalTitle: $('[data-credit-modal-title]'),
    creditModalText: $('[data-credit-modal-text]'),
    creditModalBalance: $('[data-credit-modal-balance]'),
    creditModalConfirm: $('[data-credit-confirm]'),
    creditModalCancel: $('[data-credit-cancel]'),
    qualityPanel: $('[data-quality-panel]'),
    qualityBusy: $('[data-quality-busy]'),
    qualityOverall: $('[data-quality-overall]'),
    qualityScore: $('[data-quality-score]'),
    seeZones: $('[data-action="see-zones"]'),
    retryMaestro: $('[data-action="retry-maestro"]'),
    zonesModal: $('[data-zones-modal]'),
    zonesList: $('[data-zones-list]'),
    zoneToggles: $('[data-zone-toggles]'),
    zoneOverlay: $('[data-zone-overlay]'),
    zoneToggleThin: $('[data-zone-toggle="thin"]'),
    zoneToggleSemi: $('[data-zone-toggle="semi"]'),
    zoneLayerThin: $('[data-zone-layer="thin"]'),
    zoneLayerSemi: $('[data-zone-layer="semi"]'),
    qualityItems: {
      dpi: $('[data-quality-item="dpi"]'),
      size: $('[data-quality-item="size"]'),
      whitespace: $('[data-quality-item="whitespace"]'),
      semi: $('[data-quality-item="semi"]'),
      transparent: $('[data-quality-item="transparent"]'),
      thin: $('[data-quality-item="thin"]'),
      colors: $('[data-quality-item="colors"]'),
    },
    qualityValues: {
      dpi: $('[data-quality-value="dpi"]'),
      size: $('[data-quality-value="size"]'),
      whitespace: $('[data-quality-value="whitespace"]'),
      semi: $('[data-quality-value="semi"]'),
      transparent: $('[data-quality-value="transparent"]'),
      thin: $('[data-quality-value="thin"]'),
      colors: $('[data-quality-value="colors"]'),
    },
    sizePanel: $('[data-size-panel]'),
    drawers: {
      vectorize: $('[data-drawer="vectorize"]'),
      removeBg: $('[data-drawer="remove-bg"]'),
      semi: $('[data-drawer="semi"]'),
      colors: $('[data-drawer="colors"]'),
      adjust: $('[data-drawer="adjust"]'),
      crop: $('[data-drawer="crop"]'),
    },
  };

  const workCanvas = document.createElement('canvas');
  const workCtx = workCanvas.getContext('2d', { willReadFrequently: true });
  const previewCtx = refs.previewCanvas.getContext('2d', { willReadFrequently: true });
  workCanvas.width = 0;
  workCanvas.height = 0;

  const creditConfig = {
    required: root.dataset.creditRequired === 'true',
    apiBase: root.dataset.creditApiBase || 'https://innovative-stack-i1z8l.ampt.app/api/v1',
    // Ledger bridge mirrors Ampt balance into Shopify Jetons PMD+ (custom.sub_usage)
    ledgerBase: root.dataset.creditLedgerBase || root.dataset.creditApiBase || 'https://innovative-stack-i1z8l.ampt.app/api/v1',
    buyUrl: root.dataset.creditBuyUrl || 'https://www.sherpa-transfert.com/products/credits-supplementaires-printmydtf',
    customerId: root.dataset.customerId || '',
    isLoggedIn: root.dataset.customerLoggedIn === 'true',
    metafieldNamespace: root.dataset.creditMetafieldNamespace || 'custom',
    metafieldKey: root.dataset.creditMetafieldKey || 'sub_usage',
    freeDownloadEnabled: root.dataset.freeDownloadEnabled !== 'false',
    freeDownloadUsed: parseFlag(root.dataset.freeDownloadUsed),
    freeDownloadStoragePrefix: root.dataset.freeDownloadStoragePrefix || 'sherpa-logo-editor-free-download',
    initialBalance: parseCreditBalance(root.dataset.creditBalance),
  };

  const state = {
    fileName: '',
    fileKind: '',
    zoom: 1,
    history: [],
    redo: [],
    palette: [],
    detectedColorCount: 0,
    vectorColorsAuto: null,
    vectorSvg: '',
    vectorMeta: null,
    vectorObjectUrl: '',
    vectorPdfBlob: null,
    vectorExportReady: false,
    vectorSourceBlob: null,
    uploadFile: null,
    sourceIsVector: false,
    maestroFilename: '',
    maestroValidations: null,
    maestroValidating: false,
    maestroError: '',
    maestroCache: {},
    printWidthCm: 0,
    printHeightCm: 0,
    upscalerInstance: null,
    upscalerReady: false,
    crop: null,
    drag: null,
    pan: null,
    inputLock: false,
    isBusy: false,
    creditsBalance: creditConfig.initialBalance,
    creditsReady: !creditConfig.required || creditConfig.initialBalance !== null,
    creditsLoading: false,
    creditsConsuming: false,
    freeDownloadUsed: readFreeDownloadUsed(),
    qualityCache: null,
  };

  let pendingVectorPdf = null;
  let vectorPdfEpoch = 0;

  // Keep enough for ~60 cm @ 300 DPI when the logo editor is used standalone.
  const MAX_IMPORT_EDGE = 7000;
  const MAX_OUTPUT_EDGE = 12000;
  // Ampt / gateway often drop oversized multipart uploads as "Failed to fetch"
  // (seen around ~5 Mo raw PNG). Product pages gate at MAX_MB; here we re-encode.
  const MAX_AMPT_UPLOAD_BYTES = 4 * 1024 * 1024;
  const MAX_AMPT_UPLOAD_EDGE = 2048;
  const DPI = 300;
  const CM_PER_INCH = 2.54;
  const MAESTRO_VALIDATE_URL = root.dataset.apiValidateUrl || '/apps/easy-order/file/validate';
  const MAESTRO_INFOS_URL = root.dataset.apiInfosUrl || '/apps/easy-order/file/infos';
  let creditModalResolve = null;
  let maestroRequestSeq = 0;

  init();

  function init() {
    if (window.pdfjsLib) {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = root.dataset.pdfWorkerUrl || 'shopify-theme/assets/pdf.worker.min.js';
    }

    hideVectorStage();
    bindEvents();
    refs.zonesModal?.addEventListener('click', (event) => {
      if (event.target === refs.zonesModal) closeMaestroZones();
    });
    bindStageProtection();
    bindMesFichiersLibrary();
    updateRangeLabels();
    configureHostMode();
    refreshCredits();
    updateInterface();
    if (root.__logoEditorHost) {
      void bootstrapHostSession();
    } else if (new URLSearchParams(window.location.search).has('demo')) {
      window.setTimeout(loadDemoLogo, 80);
    }
  }

  function bindMesFichiersLibrary() {
    if (!window.MesFichiersLibrary?.mount) return;
    const overlay = $('[data-mf-library-overlay]');
    const openButton = $('[data-library-open]');
    if (!overlay || !openButton) return;
    window.MesFichiersLibrary.mount({
      root,
      overlay,
      openButton,
      addLabel: 'Ouvrir',
      toast: (message, tone) => showToast(message, tone === 'good' ? 'good' : tone === 'error' ? 'error' : ''),
      onImport: async (file, extras) => {
        await loadFile(file, extras);
      },
    });
  }

  function configureHostMode() {
    const host = root.__logoEditorHost;
    if (!host || host.mode !== 'apply') return;
    root.dataset.hostMode = 'apply';
    if (refs.creditPill) refs.creditPill.hidden = true;
    if (refs.saveLibrary) refs.saveLibrary.hidden = true;
    if (!refs.downloadPdf) return;
    refs.downloadPdf.dataset.action = 'apply-to-host';
    refs.downloadPdf.classList.add('le-btn-apply-host');
    refs.downloadPdf.setAttribute('title', 'Appliquer le logo modifié à la planche');
    refs.downloadPdf.setAttribute('aria-label', 'Appliquer le logo modifié à la planche');
    refs.downloadPdf.innerHTML = `
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3.5 8.2 6.7 11.4 12.5 4.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <span>Appliquer</span>
    `;
  }

  async function bootstrapHostSession() {
    const host = root.__logoEditorHost;
    if (!host) return;
    if (!host.file) return;
    try {
      await loadFile(host.file);
      if (host.printWidthCm > 0 && host.printHeightCm > 0) {
        setPrintSize(host.printWidthCm, host.printHeightCm);
        updateInterface();
        render();
      }
    } catch (error) {
      console.error(error);
      showToast(error?.message || 'Import impossible', 'error');
    }
  }

  function bindDrawerAccordion() {
    const drawers = Object.values(refs.drawers || {}).filter(Boolean);
    drawers.forEach((drawer) => {
      drawer.addEventListener('toggle', () => {
        if (!drawer.open) return;
        drawers.forEach((other) => {
          if (other !== drawer && other.open) other.open = false;
        });
      });
    });
  }

  function bindStageProtection() {
    const blockContextMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
      return false;
    };
    const blockDrag = (event) => {
      event.preventDefault();
      return false;
    };

    [refs.canvasZone, refs.previewCanvas, refs.stageStack, refs.vectorPreview].filter(Boolean).forEach((el) => {
      el.addEventListener('contextmenu', blockContextMenu);
      el.addEventListener('dragstart', blockDrag);
    });

    if (refs.previewCanvas) {
      refs.previewCanvas.draggable = false;
    }
  }

  function bindEvents() {
    refs.fileInput.addEventListener('change', (event) => {
      const [file] = Array.from(event.target.files || []);
      if (file) loadFile(file);
      event.target.value = '';
    });

    ['dragenter', 'dragover'].forEach((name) => {
      root.addEventListener(name, (event) => {
        if (!event.dataTransfer?.types?.includes('Files')) return;
        event.preventDefault();
        setImportDragging(true);
      });
    });

    ['dragleave', 'drop'].forEach((name) => {
      root.addEventListener(name, () => setImportDragging(false));
    });

    root.addEventListener('drop', (event) => {
      const files = Array.from(event.dataTransfer?.files || []);
      if (!files.length) return;
      event.preventDefault();
      setImportDragging(false);
      loadFile(files[0]);
    });

    root.addEventListener('click', (event) => {
      const actionButton = event.target.closest('[data-action]');
      if (!actionButton) return;
      const action = actionButton.dataset.action;
      runAction(action);
    });

    root.addEventListener('change', (event) => {
      const zoneLayer = event.target.closest('[data-zone-layer]');
      if (zoneLayer) {
        const key = zoneLayer.dataset.zoneLayer;
        if (zoneLayer.checked) setZoneOverlay(key);
        else if (!refs.zoneLayerThin?.checked && !refs.zoneLayerSemi?.checked) clearZoneOverlay();
        return;
      }
      const colorSelect = event.target.closest('[data-color-select]');
      if (!colorSelect) return;
      colorSelect.closest('.le-color-row')?.classList.toggle('is-selected', colorSelect.checked);
      updateColorBulkVisibility();
    });

    [refs.semiThreshold, refs.textileTolerance, refs.colorTolerance, refs.resizeScale, refs.adjustBrightness, refs.adjustContrast, refs.adjustSaturation].filter(Boolean).forEach((input) => {
      input.addEventListener('input', () => {
        updateRangeLabels();
        if (input === refs.resizeScale) updateResizeInputsFromScale();
        if (input === refs.colorTolerance) {
          detectPalette();
          renderColorList();
        }
      });
    });

    refs.upscaleEngine.addEventListener('change', updateInterface);

    refs.resizeWidth.addEventListener('input', () => updatePairedResizeInput('width'));
    refs.resizeHeight.addEventListener('input', () => updatePairedResizeInput('height'));

    bindDrawerAccordion();

    refs.previewCanvas.addEventListener('pointerdown', onCanvasPointerDown);
    refs.vectorStage.addEventListener('pointerdown', onCanvasPointerDown);
    refs.canvasZone.addEventListener('wheel', onCanvasWheel, { passive: false });
    refs.creditModalConfirm?.addEventListener('click', () => closeCreditModal(true));
    refs.creditModalCancel?.addEventListener('click', () => closeCreditModal(false));
    refs.creditModal?.addEventListener('click', (event) => {
      if (event.target === refs.creditModal) closeCreditModal(false);
    });
    window.addEventListener('pointermove', onCanvasPointerMove);
    window.addEventListener('pointerup', onCanvasPointerUp);

    window.addEventListener('resize', () => {
      if (hasImage()) fitToView(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && refs.creditModal && !refs.creditModal.hidden) {
        closeCreditModal(false);
        return;
      }
      const meta = event.metaKey || event.ctrlKey;
      if (!meta || event.shiftKey) return;
      if (event.key.toLowerCase() === 'z') {
        event.preventDefault();
        undo();
      } else if (event.key.toLowerCase() === 'y') {
        event.preventDefault();
        redo();
      }
    });
  }

  async function runAction(action) {
    const actions = {
      undo,
      redo,
      fit: () => fitToView(),
      'zoom-in': () => setZoom(state.zoom * 1.18),
      'zoom-out': () => setZoom(state.zoom / 1.18),
      'close-editor': closeEditor,
      'download-pdf': downloadPdf,
      'save-library': saveToLibrary,
      'apply-to-host': applyToHost,
      'pick-file': pickImportFile,
      'sample-bg': sampleBackgroundFromEdges,
      'remove-bg': removeBackground,
      'remove-semi-transparency': removeSemiTransparency,
      'remove-textile-color': removeTextileColor,
      trim: () => trimWhitespace(true),
      'start-crop': startCrop,
      'cancel-crop': cancelCrop,
      'apply-crop': applyCrop,
      'auto-crop': autoCropBox,
      resize: resizeLogo,
      upscale: upscaleLogo,
      'apply-adjustments': applyImageAdjustments,
      'reset-adjustments': resetAdjustmentControls,
      'rotate-left': () => rotateLogo(-90),
      'rotate-right': () => rotateLogo(90),
      'rotate-180': () => rotateLogo(180),
      'apply-bulk-color': applyBulkColorToSelection,
      'clear-color-selection': clearColorSelection,
      'apply-colors': applyColorChanges,
      vectorize,
      reset: resetEditor,
      'see-zones': openMaestroZones,
      'close-zones': closeMaestroZones,
      'retry-maestro': () => { void refreshMaestroValidation({ force: true }); },
    };
    const rasterActions = [
      'sample-bg',
      'remove-bg',
      'remove-semi-transparency',
      'remove-textile-color',
      'trim',
      'start-crop',
      'cancel-crop',
      'apply-crop',
      'auto-crop',
      'apply-colors',
    ];
    // 'resize' ne touche pas aux pixels, seulement aux centimetres d'impression :
    // jeter le vectoriel la-dessus renverrait un PDF pixel apres vectorisation.
    if (state.vectorSvg && rasterActions.includes(action)) {
      clearVector();
      render();
    }
    if (actions[action]) await actions[action]();
  }

  function pickImportFile() {
    if (hasImage()) return;
    refs.fileInput?.click();
  }

  function setImportDragging(active) {
    refs.dropzone?.classList.toggle('is-dragging', active && !hasImage());
    refs.canvasZone?.classList.toggle('is-dragging', active && !hasImage());
    refs.emptyState?.classList.toggle('is-dragging', active && !hasImage());
  }

  function isVectorFile() {
    return Boolean(state.sourceIsVector || state.vectorExportReady || state.vectorSvg);
  }

  // Vectorised inside the editor: the artwork is now paths, so the Maestro
  // verdict — computed on the raster we uploaded before vectorising — no longer
  // describes it. A source PDF/AI is excluded: there Maestro can legitimately
  // flag a low-resolution raster embedded in the vector container.
  function isVectorizedInApp() {
    return Boolean(state.vectorExportReady || state.vectorSvg);
  }

  function isMaestroInvalid(check) {
    return Boolean(check && typeof check === 'object' && check.is_valid === false);
  }

  function maestroAlerts(validations) {
    const v = validations || state.maestroValidations || {};
    return {
      resolution: !isVectorizedInApp() && isMaestroInvalid(v.IMAGE_RESOLUTION_TROP_FAIBLE),
      thin: isMaestroInvalid(v.thickness),
      semi: isMaestroInvalid(v.mid_transparency),
      background: isMaestroInvalid(v.transparency),
      colors: isMaestroInvalid(v.ESPACE_COULEUR_TON_DIRECT),
    };
  }

  function hasMaestroResult() {
    return Boolean(state.maestroValidations && typeof state.maestroValidations === 'object');
  }

  function currentQuality() {
    if (!hasImage()) return null;
    if (!state.qualityCache) state.qualityCache = analyzeLogoQuality();
    return state.qualityCache;
  }

  function needsRemoveBackground() {
    const quality = currentQuality();
    if (!quality || !quality.hasContent) return false;
    if (quality.transparentBackground) return false;
    if (hasMaestroResult()) return maestroAlerts().background;
    return true;
  }

  function needsTrimWhitespace() {
    const quality = currentQuality();
    return Boolean(quality && quality.hasContent && quality.hasWhitespace);
  }

  function needsVectorize() {
    if (hasMaestroResult()) return maestroAlerts().resolution;
    return !isVectorFile();
  }

  function needsCleanSemi() {
    const quality = currentQuality();
    if (!quality || !quality.hasContent) return false;
    if (hasMaestroResult()) return maestroAlerts().semi;
    return Boolean(quality.hasSemiTransparency);
  }

  function resetMaestroState() {
    state.maestroFilename = '';
    state.maestroValidations = null;
    state.maestroValidating = false;
    state.maestroError = '';
    state.maestroCache = {};
    clearZoneOverlay();
  }

  const MAESTRO_CHECK_KEYS = [
    'thickness',
    'mid_transparency',
    'transparency',
    'IMAGE_RESOLUTION_TROP_FAIBLE',
    'ESPACE_COULEUR_TON_DIRECT',
  ];

  function looksLikeMaestroValidations(value) {
    return Boolean(
      value
      && typeof value === 'object'
      && !Array.isArray(value)
      && MAESTRO_CHECK_KEYS.some((key) => value[key] && typeof value[key] === 'object')
    );
  }

  function maestroFieldFromCandidate(candidate) {
    if (!candidate || typeof candidate !== 'object') return null;
    if (typeof candidate.uploadFile === 'function') return candidate;
    const nestedKeys = ['__field', 'field', 'uploadLift'];
    for (const key of nestedKeys) {
      const nested = candidate[key];
      if (nested && typeof nested.uploadFile === 'function') return nested;
    }
    return null;
  }

  function findUploadLiftField() {
    const win = window;
    const globalField = maestroFieldFromCandidate(win.__leUploadField)
      || maestroFieldFromCandidate(win.__lnUploadField)
      || maestroFieldFromCandidate(win.field)
      || maestroFieldFromCandidate(win.uploadLiftField)
      || maestroFieldFromCandidate(win.UploadLift)
      || maestroFieldFromCandidate(win.UploadLift?.field)
      || maestroFieldFromCandidate(win.UploadLift?.fields?.[0])
      || maestroFieldFromCandidate(win.UploadLift?.instances?.[0]);
    if (globalField) return globalField;

    const containers = document.querySelectorAll('.upload-fast-order, .upload-lift, [data-upload-lift], [data-uploadlift]');
    for (const container of containers) {
      const field = maestroFieldFromCandidate(container)
        || maestroFieldFromCandidate(container.__field)
        || maestroFieldFromCandidate(container.field)
        || maestroFieldFromCandidate(container.uploadLift)
        || maestroFieldFromCandidate(container.firstElementChild)
        || maestroFieldFromCandidate(container.firstElementChild?.__field);
      if (field) return field;
      const descendants = container.querySelectorAll('*');
      for (const node of descendants) {
        const nested = maestroFieldFromCandidate(node) || maestroFieldFromCandidate(node.__field);
        if (nested) return nested;
      }
    }
    return null;
  }

  function waitForUploadLiftField(timeoutMs = 20000) {
    const startedAt = Date.now();
    return new Promise((resolve) => {
      const tick = () => {
        const field = findUploadLiftField();
        if (field) {
          resolve(field);
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          resolve(null);
          return;
        }
        window.setTimeout(tick, 120);
      };
      tick();
    });
  }

  function normalizeCloudLiftUrl(value) {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    if (/storage\.googleapis\.com\/cloudlift-app-cloud-prod-upload\//i.test(trimmed)) {
      try {
        const parts = new URL(trimmed).pathname.split('/').filter(Boolean);
        const index = parts.indexOf('cloudlift-app-cloud-prod-upload');
        const tenant = parts[index + 1];
        const key = parts[index + 2];
        if (tenant && key) return `https://upload.cloudlift.app/s/${tenant}/${key}`;
      } catch (_) { /* keep original */ }
    }
    return trimmed;
  }

  function isInternalMaestroUrl(url) {
    return /maestro-cs-public-api|localhost|127\.0\.0\.1|\.internal[:/]/i.test(String(url || ''));
  }

  function scoreMaestroUrl(url) {
    const value = String(url || '');
    if (!value || isInternalMaestroUrl(value) || isHtmlPayload(value)) return 0;
    if (/api\.cloud\.sherpa-transfert\.app\/api\/file\/get\//i.test(value)) return 6;
    if (/s3\.gra\.io\.cloud\.ovh\.net\/customer-library\//i.test(value) && /X-Amz-/i.test(value)) return 5;
    if (/upload\.cloudlift\.app\/s\//i.test(value)) return 4;
    if (/^https:\/\/s3\./i.test(value) || /storage\.googleapis\.com/i.test(value)) return 3;
    if (/^https:\/\//i.test(value)) return 2;
    if (/^http:\/\//i.test(value)) return 1;
    return 0;
  }

  function isPublicMaestroUrl(url) {
    return scoreMaestroUrl(url) >= 2;
  }

  function isStableMaestroUrl(url) {
    if (!isPublicMaestroUrl(url)) return false;
    try {
      return !new URL(String(url)).search;
    } catch (_) {
      return false;
    }
  }

  function pickMaestroUrl(...candidates) {
    const urls = candidates.map((value) => String(value || '').trim()).filter(Boolean);
    return urls.find((url) => isStableMaestroUrl(url)) || urls.find((url) => isPublicMaestroUrl(url)) || '';
  }

  function sleep(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function isHtmlPayload(value) {
    const text = String(value || '');
    return /<!doctype html|<html[\s>]|has-header-tabs/i.test(text);
  }

  function maestroUserError(error) {
    const raw = String(error?.message || error || '');
    if (isHtmlPayload(raw)) return 'Erreur serveur lors de la vérification.';
    return raw || 'Vérification impossible';
  }

  function collectUrlCandidates(value, depth = 0, found = []) {
    if (!value || depth > 6) return found;
    if (typeof value === 'string') {
      if (isHtmlPayload(value) || /ahrefs\.com|shopify\.com\/cdn/i.test(value)) return found;
      const normalized = normalizeCloudLiftUrl(value);
      if (scoreMaestroUrl(normalized) > 0) found.push(normalized);
      return found;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => collectUrlCandidates(item, depth + 1, found));
      return found;
    }
    if (typeof value !== 'object') return found;
    const preferredKeys = [
      'download_url', 'FILE_URL', 'fileUrl', 'file_url', 'url', 'downloadUrl',
      'cdnUrl', 'cdn_url', 'storageUrl', 'storage_url', 'original_url', 'value', 'file',
    ];
    preferredKeys.forEach((key) => collectUrlCandidates(value[key], depth + 1, found));
    Object.keys(value).forEach((key) => {
      if (preferredKeys.includes(key)) return;
      collectUrlCandidates(value[key], depth + 1, found);
    });
    return found;
  }

  function extractUploadUrl(value) {
    const candidates = collectUrlCandidates(value);
    if (!candidates.length) return '';
    candidates.sort((a, b) => scoreMaestroUrl(b) - scoreMaestroUrl(a));
    const best = candidates[0];
    if (/^\/(apps\/easy-order|s)\//i.test(best)) {
      return new URL(best, window.location.origin).toString();
    }
    return best;
  }

  async function maestroFetch(url, options = {}) {
    const response = await fetch(url, {
      cache: 'no-store',
      credentials: 'same-origin',
      ...options,
      headers: { Accept: 'application/json', ...(options.headers || {}) },
    });
    return parseProxyJson(response);
  }

  async function parseProxyJson(response) {
    const text = await response.text();
    if (isHtmlPayload(text)) {
      const error = new Error('Erreur serveur lors de la vérification.');
      error.status = response.status || 500;
      throw error;
    }
    let json = null;
    try { json = text ? JSON.parse(text) : null; } catch (_) { json = null; }
    if (!response.ok) {
      const error = new Error(
        json?.message || json?.error || json?.STATUS_DESCRIPTION || `HTTP ${response.status}`
      );
      error.status = response.status;
      throw error;
    }
    if (json && Number(json.STATUS_CODE) && Number(json.STATUS_CODE) !== 200) {
      throw new Error(json.STATUS_DESCRIPTION || json.message || 'Erreur Maestro');
    }
    return json;
  }

  async function ensureMaestroFilename() {
    if (isPublicMaestroUrl(state.maestroFilename)) return state.maestroFilename;
    if (!state.uploadFile) throw new Error('Aucun fichier à vérifier.');
    const storageUrl = await uploadMaestroFileViaStorage(state.uploadFile);
    state.maestroFilename = storageUrl;
    return storageUrl;
  }

  // file-storage rejects non-ASCII filenames with a 500 (it only strips spaces
  // and punctuation), so accented names like "Echantillon écusson.pdf" never
  // upload. Fold to ASCII before sending.
  function sanitizeUploadFilename(name, fallbackExt = 'png') {
    const raw = String(name || '');
    const dot = raw.lastIndexOf('.');
    const toAscii = (value) => value
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^A-Za-z0-9._-]+/g, '-');
    const stem = toAscii(dot > 0 ? raw.slice(0, dot) : raw).replace(/^-+|-+$/g, '').slice(0, 80) || 'logo';
    const ext = toAscii(dot > 0 ? raw.slice(dot + 1) : '').toLowerCase() || fallbackExt;
    return `${stem}.${ext}`;
  }

  async function fileForMaestroStorage(file) {
    const ext = String(file.name || '').split('.').pop().toLowerCase();
    if (['png', 'pdf', 'ai'].includes(ext)) {
      const safeName = sanitizeUploadFilename(file.name, ext);
      if (safeName === file.name) return file;
      return new File([file], safeName, { type: file.type || 'application/octet-stream' });
    }
    if (!hasImage()) return file;
    const blob = await canvasToPngBlob();
    const base = sanitizeUploadFilename(file.name, 'png').replace(/\.[^.]+$/, '');
    return new File([blob], `${base}.png`, { type: 'image/png' });
  }

  async function uploadMaestroFileViaStorage(file) {
    if (!creditConfig.customerId) {
      throw new Error('Connectez-vous pour vérifier le fichier.');
    }
    const uploadFile = await fileForMaestroStorage(file);
    const uploadPath = root.dataset.libraryUploadUrl || '/apps/easy-order/file-storage/upload';
    const url = new URL(uploadPath, window.location.origin);
    url.searchParams.set('user_id', creditConfig.customerId);
    const formData = new FormData();
    formData.append('file', uploadFile, uploadFile.name || 'logo.png');
    const widthMm = Math.max(1, Math.round(getPrintWidthCm() * 10));
    const heightMm = Math.max(1, Math.round(getPrintHeightCm() * 10));
    if (widthMm > 0) formData.append('width_mm', String(widthMm));
    if (heightMm > 0) formData.append('height_mm', String(heightMm));

    const uploaded = await maestroFetch(url.toString(), {
      method: 'POST',
      body: formData,
    });
    const key = String(uploaded?.key || '').trim();
    const listed = await waitForLibraryDownloadUrl(key, uploadFile.name);
    if (!listed) {
      throw new Error('L’upload n’a pas renvoyé d’URL publique de vérification.');
    }
    console.info('[LE maestro] uploaded', { key, listed: listed.slice(0, 80) });
    return listed;
  }

  function libraryFilesFrom(json) {
    if (Array.isArray(json?.files)) return json.files;
    if (Array.isArray(json?.data?.files)) return json.data.files;
    return [];
  }

  function downloadUrlFromLibraryFile(file) {
    const url = String(file?.download_url || '').trim();
    return isPublicMaestroUrl(url) ? url : '';
  }

  async function listLibraryFiles() {
    const listPath = root.dataset.libraryListUrl || '/apps/easy-order/file-storage/list';
    const url = new URL(listPath, window.location.origin);
    url.searchParams.set('user_id', creditConfig.customerId);
    return libraryFilesFrom(await maestroFetch(url.toString(), { method: 'GET' }));
  }

  async function waitForLibraryDownloadUrl(key, preferredName = '') {
    const needle = String(preferredName || '').toLowerCase();
    for (let attempt = 0; attempt < 6; attempt += 1) {
      const files = await listLibraryFiles();
      const byKey = key
        ? files.find((file) => String(file?.key || '') === key)
        : null;
      const sorted = [...files].sort(
        (a, b) => new Date(b?.last_modified || 0) - new Date(a?.last_modified || 0)
      );
      const byName = needle
        ? sorted.find((file) => {
          const hay = [
            file?.filename,
            file?.name,
            file?.key,
            file?.metadata?.original_filename,
          ].map((value) => String(value || '').toLowerCase()).join(' ');
          return hay.includes(needle);
        })
        : null;
      const url = downloadUrlFromLibraryFile(byKey)
        || downloadUrlFromLibraryFile(byName)
        || downloadUrlFromLibraryFile(sorted[0]);
      if (url) return url;
      await sleep(400);
    }
    return '';
  }

  async function resolveMaestroFilename(sourceUrl) {
    if (!sourceUrl) return '';
    try {
      const infosUrl = new URL(MAESTRO_INFOS_URL, window.location.origin);
      infosUrl.searchParams.set('filename', sourceUrl);
      infosUrl.searchParams.set('crop_transparent_area', 'false');
      const json = await maestroFetch(infosUrl.toString(), { method: 'GET' });
      return pickMaestroUrl(
        json?.FILE_CROPPED,
        json?.FILE_PNG_FULL_SIZE,
        json?.FILE_URL,
        sourceUrl
      );
    } catch (error) {
      console.warn('Maestro file/infos failed, validating source URL', error);
      return isPublicMaestroUrl(sourceUrl) ? sourceUrl : '';
    }
  }

  async function fetchMaestroValidations(filename, widthMm, heightMm) {
    const cacheKey = `${filename}::${Math.round(widthMm)}x${Math.round(heightMm)}`;
    if (state.maestroCache[cacheKey]) return state.maestroCache[cacheKey];
    const url = new URL(MAESTRO_VALIDATE_URL, window.location.origin);
    url.searchParams.set('filename', filename);
    url.searchParams.set('width', String(Math.max(1, Math.round(widthMm))));
    url.searchParams.set('height', String(Math.max(1, Math.round(heightMm))));
    url.searchParams.set('method', 'logo');
    let json;
    try {
      json = await maestroFetch(url.toString(), { method: 'GET' });
    } catch (error) {
      if (!error?.status) {
        const networkError = new Error(error?.message || 'Network error during validation');
        networkError.status = 0;
        throw networkError;
      }
      throw error;
    }
    const payload = normalizeMaestroValidations(json);
    if (!payload) throw new Error('Réponse de validation invalide');
    if (payload.ESPACE_COULEUR_HORS_CMJN) delete payload.ESPACE_COULEUR_HORS_CMJN;
    state.maestroCache[cacheKey] = payload;
    return payload;
  }

  function normalizeMaestroValidations(json) {
    if (!json || typeof json !== 'object') return null;
    const candidates = [
      json.validations,
      json.data?.validations,
      json.result?.validations,
      json.data,
      json.result,
      json,
    ];
    for (const candidate of candidates) {
      if (looksLikeMaestroValidations(candidate)) {
        return { ...candidate };
      }
    }
    const fallback = json.validations || json.data || json.result || json;
    return fallback && typeof fallback === 'object' && !Array.isArray(fallback) ? { ...fallback } : null;
  }

  function maestroAssetUrl(value) {
    const url = String(value || '').trim();
    if (!url || isHtmlPayload(url)) return '';
    return url.replace(/^http:\/\/api\.cloud\.sherpa-transfert\.app/i, 'https://api.cloud.sherpa-transfert.app');
  }

  function maestroCheckPreview(check) {
    if (!check || typeof check !== 'object') return '';
    return maestroAssetUrl(check.summary_file || check.preview_file || check.mask_file);
  }

  function maestroProblemZones() {
    if (!hasMaestroResult()) return [];
    const v = state.maestroValidations || {};
    return [
      { key: 'thin', label: 'Zones fines', check: v.thickness },
      { key: 'semi', label: 'Semi-transparence', check: v.mid_transparency },
    ].reduce((list, item) => {
      if (!isMaestroInvalid(item.check)) return list;
      const url = maestroCheckPreview(item.check);
      if (!url) return list;
      list.push({ key: item.key, label: item.label, url });
      return list;
    }, []);
  }

  function maestroZoneByKey(key) {
    return maestroProblemZones().find((zone) => zone.key === key) || null;
  }

  function clearZoneOverlay() {
    if (refs.zoneLayerThin) refs.zoneLayerThin.checked = false;
    if (refs.zoneLayerSemi) refs.zoneLayerSemi.checked = false;
    if (refs.zoneOverlay) {
      refs.zoneOverlay.hidden = true;
      refs.zoneOverlay.removeAttribute('src');
      refs.zoneOverlay.alt = '';
    }
  }

  function setZoneOverlay(key) {
    const zone = maestroZoneByKey(key);
    if (!refs.zoneOverlay || !zone) {
      clearZoneOverlay();
      return;
    }
    if (refs.zoneLayerThin) refs.zoneLayerThin.checked = key === 'thin';
    if (refs.zoneLayerSemi) refs.zoneLayerSemi.checked = key === 'semi';
    refs.zoneOverlay.alt = zone.label;
    refs.zoneOverlay.src = zone.url;
    refs.zoneOverlay.hidden = false;
  }

  function updateZoneToggles() {
    const zones = maestroProblemZones();
    const thin = zones.find((zone) => zone.key === 'thin');
    const semi = zones.find((zone) => zone.key === 'semi');
    if (refs.zoneToggleThin) refs.zoneToggleThin.hidden = !thin;
    if (refs.zoneToggleSemi) refs.zoneToggleSemi.hidden = !semi;
    if (refs.zoneToggles) refs.zoneToggles.hidden = !thin && !semi;
    const active = refs.zoneLayerThin?.checked
      ? 'thin'
      : refs.zoneLayerSemi?.checked
        ? 'semi'
        : '';
    if (active && maestroZoneByKey(active)) setZoneOverlay(active);
    else clearZoneOverlay();
  }

  function openMaestroZones() {
    const zones = maestroProblemZones();
    if (!zones.length || !refs.zonesModal || !refs.zonesList) {
      showToast('Aucune image de zone renvoyée par la vérification', 'error');
      return;
    }
    refs.zonesList.innerHTML = zones.map((zone) => `
      <figure class="le-zones-figure">
        <figcaption>${escapeHtml(zone.label)}</figcaption>
        <img src="${escapeHtml(zone.url)}" alt="${escapeHtml(zone.label)}">
      </figure>
    `).join('');
    refs.zonesModal.hidden = false;
  }

  function closeMaestroZones() {
    if (refs.zonesModal) refs.zonesModal.hidden = true;
    if (refs.zonesList) refs.zonesList.innerHTML = '';
  }

  async function refreshMaestroValidation(options = {}) {
    if (!hasImage() || !state.uploadFile) return;
    const seq = (maestroRequestSeq += 1);
    const force = Boolean(options.force);
    if (force) {
      state.maestroCache = {};
      state.maestroFilename = '';
    }
    state.maestroValidating = true;
    state.maestroError = '';
    state.maestroValidations = null;
    state.qualityCache = null;
    updateQualityPanel(true);
    try {
      const sourceUrl = await ensureMaestroFilename();
      if (seq !== maestroRequestSeq) return;
      const filename = await resolveMaestroFilename(sourceUrl);
      if (!filename) throw new Error('URL de vérification manquante.');
      state.maestroFilename = filename;
      if (seq !== maestroRequestSeq) return;
      const widthMm = Math.max(1, Math.round(getPrintWidthCm() * 10));
      const heightMm = Math.max(1, Math.round(getPrintHeightCm() * 10));
      console.info('[LE maestro] validate', { filename: filename.slice(0, 96), widthMm, heightMm });
      const validations = await fetchMaestroValidationsWithRetry(filename, widthMm, heightMm);
      if (seq !== maestroRequestSeq) return;
      state.maestroValidations = validations;
      state.maestroError = '';
      state.qualityCache = null;
    } catch (error) {
      if (seq !== maestroRequestSeq) return;
      console.warn('Maestro validate failed', error);
      state.maestroValidations = null;
      state.maestroError = maestroUserError(error);
      showToast(state.maestroError, 'error');
    } finally {
      if (seq === maestroRequestSeq) {
        state.maestroValidating = false;
        updateInterface();
      }
    }
  }

  async function fetchMaestroValidationsWithRetry(filename, widthMm, heightMm) {
    let lastError = null;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        return await fetchMaestroValidations(filename, widthMm, heightMm);
      } catch (error) {
        lastError = error;
        const status = Number(error?.status || 0);
        const retryable = status === 0 || status === 500 || status === 502 || status === 503 || status === 504 || status === -1;
        if (!retryable || attempt === 2) throw error;
        await new Promise((resolve) => window.setTimeout(resolve, 4000));
      }
    }
    throw lastError || new Error('Vérification impossible');
  }

  async function loadFile(file, extras = {}) {
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    const isPdfLike = ext === 'pdf' || ext === 'ai' || file.type === 'application/pdf' || file.type === 'application/postscript' || file.type === 'application/illustrator';
    const isRaster = file.type.startsWith('image/') || ['png', 'jpg', 'jpeg', 'webp'].includes(ext);

    if (!isPdfLike && !isRaster) {
      showToast('Format non supporte', 'error');
      return;
    }

    setBusy(`Import de ${file.name}`);
    setStageLoading(true, 'Chargement du logo', 'Import du fichier');
    await nextFrame();
    try {
      clearVector();
      resetMaestroState();
      state.uploadFile = file;
      const knownUrl = downloadUrlFromLibraryFile(extras?.fileMeta)
        || extractUploadUrl(extras?.sourceUrl)
        || extractUploadUrl(extras?.fileMeta);
      if (isPublicMaestroUrl(knownUrl)) state.maestroFilename = knownUrl;
      state.sourceIsVector = isPdfLike;
      let importedCanvas;
      if (isPdfLike) {
        importedCanvas = await importPdfLike(file);
      } else {
        importedCanvas = await importRaster(file);
      }

      setWorkCanvas(importedCanvas, file.name, isPdfLike ? 'PDF/AI' : 'Image');
      const trimmedOnImport = trimWhitespace(false, false);
      state.history = [];
      state.redo = [];
      pushHistory(trimmedOnImport ? 'Import sans espaces vides' : 'Import');
      sampleBackgroundFromEdges(false);
      detectPalette();
      syncVectorColorsDefault(true);
      fitToView(false);
      render();
      pulseSizePanel();
      showToast(trimmedOnImport ? 'Logo importe sans espaces vides' : 'Logo importe', 'good');
      void refreshMaestroValidation();
    } catch (error) {
      console.error(error);
      showToast(error.message || 'Import impossible', 'error');
    } finally {
      setStageLoading(false);
      setBusy('Pret');
    }
  }

  function loadDemoLogo() {
    const canvas = document.createElement('canvas');
    canvas.width = 680;
    canvas.height = 420;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#2563eb';
    roundedRect(ctx, 96, 88, 488, 178, 34);
    ctx.fill();
    ctx.fillStyle = '#16a34a';
    ctx.beginPath();
    ctx.arc(170, 176, 58, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#111827';
    ctx.font = '900 96px Arial, sans-serif';
    ctx.letterSpacing = '0px';
    ctx.fillText('AMG', 244, 208);
    ctx.fillStyle = '#d97706';
    ctx.fillRect(244, 234, 244, 18);

    setWorkCanvas(canvas, 'demo-logo.png', 'Demo');
    state.history = [];
    state.redo = [];
    pushHistory('Demo');
    sampleBackgroundFromEdges(false);
    detectPalette();
    syncVectorColorsDefault(true);
    fitToView(false);
    render();
  }

  async function importRaster(file) {
    // Avoid FileReader→data URL→Image (huge base64 round-trip). Decode blob directly.
    if (typeof createImageBitmap === 'function') {
      try {
        let bitmap = await createImageBitmap(file);
        const scale = Math.min(1, MAX_IMPORT_EDGE / Math.max(bitmap.width, bitmap.height));
        if (scale < 0.999) {
          const resized = await createImageBitmap(bitmap, {
            resizeWidth: Math.max(1, Math.round(bitmap.width * scale)),
            resizeHeight: Math.max(1, Math.round(bitmap.height * scale)),
            resizeQuality: 'high',
          });
          bitmap.close?.();
          bitmap = resized;
        }
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, bitmap.width);
        canvas.height = Math.max(1, bitmap.height);
        const ctx = canvas.getContext('2d', { alpha: true });
        ctx.imageSmoothingEnabled = scale < 0.999;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bitmap, 0, 0);
        bitmap.close?.();
        return canvas;
      } catch (error) {
        console.warn('importRaster createImageBitmap failed, fallback data URL', error);
      }
    }

    const src = await readFileAsDataURL(file);
    const image = await loadImage(src);
    const canvas = document.createElement('canvas');
    const scale = Math.min(1, MAX_IMPORT_EDGE / Math.max(image.naturalWidth, image.naturalHeight));
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const ctx = canvas.getContext('2d', { alpha: true });
    ctx.imageSmoothingEnabled = scale < 0.999;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
  }

  async function importPdfLike(file) {
    if (!window.pdfjsLib) throw new Error('Lecteur PDF indisponible');
    const buffer = await file.arrayBuffer();
    const doc = await window.pdfjsLib.getDocument({ data: buffer }).promise;
    if (!doc.numPages) throw new Error('PDF vide');

    if (doc.numPages > 1) {
      showToast('Premiere page importee');
    }

    const page = await doc.getPage(1);
    const viewportBase = page.getViewport({ scale: 1 });
    const renderScale = Math.min(300 / 72, MAX_IMPORT_EDGE / Math.max(viewportBase.width, viewportBase.height));
    const viewport = page.getViewport({ scale: renderScale });
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(viewport.width));
    canvas.height = Math.max(1, Math.round(viewport.height));
    const ctx = canvas.getContext('2d', { alpha: true });
    await page.render({ canvasContext: ctx, viewport, background: 'rgba(0,0,0,0)' }).promise;
    return canvas;
  }

  function setWorkCanvas(sourceCanvas, fileName, kind) {
    workCanvas.width = sourceCanvas.width;
    workCanvas.height = sourceCanvas.height;
    workCtx.clearRect(0, 0, workCanvas.width, workCanvas.height);
    workCtx.drawImage(sourceCanvas, 0, 0);
    state.fileName = fileName || 'logo';
    state.fileKind = kind || '';
    state.crop = null;
    state.drag = null;
    state.pan = null;
    state.zoom = 1;
    setPrintSizeFromPixels();
    state.qualityCache = null;
  }

  function hasImage() {
    return workCanvas.width > 0 && workCanvas.height > 0;
  }

  function withImage() {
    if (hasImage()) return true;
    showToast('Importez un logo', 'error');
    return false;
  }

  async function refreshCredits() {
    if (!creditConfig.required) {
      updateCreditUI();
      return null;
    }

    if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
      state.creditsReady = true;
      updateCreditUI();
      return null;
    }

    state.creditsLoading = true;
    updateCreditUI();

    // Same source of truth as vectorisation-automatique / upload_image.js: Ampt ledger.
    // Shopify metafield is only a fallback when the API is unreachable.
    const metafieldBalance = parseCreditBalance(root.dataset.creditBalance);
    try {
      const response = await fetch(`${creditConfig.ledgerBase}/credit/balance?customer_id=${encodeURIComponent(creditConfig.customerId)}`);
      if (response.ok) {
        const data = await response.json().catch(() => ({}));
        const amptBalance = parseCreditBalance(data.balance ?? data);
        if (amptBalance !== null) {
          state.creditsBalance = amptBalance;
        } else if (metafieldBalance !== null) {
          state.creditsBalance = metafieldBalance;
        }
      } else if (state.creditsBalance === null) {
        state.creditsBalance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
      }
    } catch (error) {
      console.warn('Credit balance failed:', error);
      if (state.creditsBalance === null) {
        state.creditsBalance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
      }
    }
    if (state.creditsBalance === null) state.creditsBalance = 0;
    state.creditsReady = true;
    state.creditsLoading = false;
    root.dataset.creditBalance = String(state.creditsBalance);
    updateCreditUI();
    return state.creditsBalance;
  }

  function applyConsumedCreditBalance(beforeBalance, responseBalance) {
    const localNext = Math.max(0, (Number(beforeBalance) || 0) - 1);
    // Match upload_image.js: prefer API balance, else local decrement.
    state.creditsBalance = responseBalance !== null ? responseBalance : localNext;
    state.creditsReady = true;
    root.dataset.creditBalance = String(state.creditsBalance);
    updateCreditUI();
  }

  async function ensureAiCredits() {
    if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
      redirectToLogin();
      return false;
    }
    await refreshCredits();
    if (!state.creditsReady) {
      showToast('Verification des credits impossible', 'error');
      return false;
    }
    if (Number(state.creditsBalance) <= 0) {
      redirectToBuyCredits();
      return false;
    }
    return true;
  }

  async function consumeAiCredit(label = '1 crédit consommé') {
    const beforeBalance = Number(state.creditsBalance);
    state.creditsConsuming = true;
    updateInterface();
    try {
      const response = await fetch(`${creditConfig.ledgerBase}/credit/use`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: creditConfig.customerId }),
      });
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) redirectToBuyCredits();
        else showToast('Verification des credits impossible', 'error');
        return false;
      }
      const data = await response.json().catch(() => ({}));
      const responseBalance = parseCreditBalance(data.balance ?? data);
      applyConsumedCreditBalance(beforeBalance, responseBalance);
      showToast(label, 'good');
      return true;
    } catch (error) {
      console.warn('Credit use failed:', error);
      showToast('Verification des credits impossible', 'error');
      return false;
    } finally {
      state.creditsConsuming = false;
      updateInterface();
    }
  }

  function canvasToPngBlob() {
    return new Promise((resolve, reject) => {
      workCanvas.toBlob((blob) => {
        if (!blob) reject(new Error('Export canvas impossible'));
        else resolve(blob);
      }, 'image/png');
    });
  }

  async function loadBlobIntoWorkCanvas(blob, label, options = {}) {
    const canvas = await decodeBlobToCanvas(blob);
    commitCanvasResult(canvas, label, options);
    state.qualityCache = null;
    if (!options.preserveVectorExport) {
      clearVector();
    }
    updateQualityPanel(true);
  }

  async function decodeBlobToCanvas(blob) {
    const typed = blob?.type
      ? blob
      : new Blob([blob], { type: 'image/png' });
    if (!typed || !typed.size) throw new Error('Résultat invalide (fichier vide)');

    if (typeof createImageBitmap === 'function') {
      try {
        const bitmap = await createImageBitmap(typed);
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, bitmap.width || 0);
        canvas.height = Math.max(1, bitmap.height || 0);
        if (canvas.width <= 1 && canvas.height <= 1) {
          bitmap.close?.();
          throw new Error('Résultat invalide (dimensions vides)');
        }
        const ctx = canvas.getContext('2d', { alpha: true, willReadFrequently: true });
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(bitmap, 0, 0);
        bitmap.close?.();
        return canvas;
      } catch (error) {
        console.warn('createImageBitmap failed, fallback Image()', error);
      }
    }

    const url = URL.createObjectURL(typed);
    try {
      const image = await loadImageElement(url);
      const width = Math.max(1, image.naturalWidth || image.width || 0);
      const height = Math.max(1, image.naturalHeight || image.height || 0);
      if (width <= 1 && height <= 1) {
        throw new Error('Résultat invalide (dimensions vides)');
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d', { alpha: true, willReadFrequently: true });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);
      return canvas;
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  function measureTransparencyRatio(source, width, height) {
    let data;
    let total;
    if (source && source.data && source.width && source.height) {
      data = source.data;
      total = source.width * source.height;
    } else {
      const canvas = source && source.canvas ? source.canvas : source;
      const ctx = source && typeof source.getImageData === 'function'
        ? source
        : canvas.getContext('2d', { willReadFrequently: true });
      const w = width || canvas.width;
      const h = height || canvas.height;
      data = ctx.getImageData(0, 0, w, h).data;
      total = w * h;
    }
    let transparent = 0;
    const step = Math.max(1, Math.floor(total / 40000));
    let sampled = 0;
    for (let p = 0; p < total; p += step) {
      sampled += 1;
      if (data[p * 4 + 3] < 16) transparent += 1;
    }
    return sampled ? transparent / sampled : 0;
  }

  function paintRasterStage() {
    clearVector();
    hideVectorStage();
    if (!refs.previewCanvas || !hasImage()) return;
    const displayWidth = `${Math.max(1, Math.round(workCanvas.width * state.zoom))}px`;
    const displayHeight = `${Math.max(1, Math.round(workCanvas.height * state.zoom))}px`;
    refs.previewCanvas.style.width = displayWidth;
    refs.previewCanvas.style.height = displayHeight;
    if (refs.stageStack) {
      refs.stageStack.style.width = displayWidth;
      refs.stageStack.style.height = displayHeight;
      refs.stageStack.classList.add('is-visible');
    }
    refs.previewCanvas.width = workCanvas.width;
    refs.previewCanvas.height = workCanvas.height;
    previewCtx.clearRect(0, 0, workCanvas.width, workCanvas.height);
    previewCtx.drawImage(workCanvas, 0, 0);
    refs.previewCanvas.classList.add('is-visible');
    refs.previewCanvas.classList.remove('is-cropping');
    refs.canvasZone?.classList.add('has-image');
    refs.emptyState && (refs.emptyState.hidden = true);
  }

  function loadImageElement(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Image invalide'));
      image.src = src;
    });
  }

  async function sniffAmptImageBlob(blob, contentType = '') {
    const header = (contentType || blob.type || '').toLowerCase();
    const magic = new Uint8Array(await blob.slice(0, 16).arrayBuffer().catch(() => new ArrayBuffer(0)));
    const isPng = magic.length >= 4 && magic[0] === 0x89 && magic[1] === 0x50 && magic[2] === 0x4e && magic[3] === 0x47;
    const isJpeg = magic.length >= 3 && magic[0] === 0xff && magic[1] === 0xd8 && magic[2] === 0xff;
    const isWebp = magic.length >= 12
      && magic[0] === 0x52 && magic[1] === 0x49 && magic[2] === 0x46 && magic[3] === 0x46
      && magic[8] === 0x57 && magic[9] === 0x45 && magic[10] === 0x42 && magic[11] === 0x50;
    const probe = (!isPng && !isJpeg && !isWebp)
      ? await blob.slice(0, 512).text().catch(() => '')
      : '';
    const isSvg = !isPng && !isJpeg && !isWebp && (
      header.includes('svg')
      || header.includes('xml')
      || /^\s*<\?xml/i.test(probe)
      || /^\s*<svg[\s>]/i.test(probe)
    );
    if (isSvg) {
      const text = await blob.text();
      return {
        kind: 'svg',
        text,
        blob: new Blob([text], { type: 'image/svg+xml' }),
      };
    }
    const type = isPng || header.includes('png')
      ? 'image/png'
      : isJpeg || header.includes('jpeg') || header.includes('jpg')
        ? 'image/jpeg'
        : isWebp || header.includes('webp')
          ? 'image/webp'
          : 'image/png';
    return {
      kind: 'raster',
      blob: blob.type === type ? blob : new Blob([blob], { type }),
    };
  }

  function setVectorSidebarPreview(blobOrUrl) {
    if (!refs.vectorPreview) return;
    refs.vectorPreview.innerHTML = '';
    if (!blobOrUrl) {
      refs.vectorPreview.innerHTML = '<span>Aucun résultat</span>';
      return;
    }
    const image = document.createElement('img');
    image.alt = 'Aperçu vectorisé';
    image.decoding = 'async';
    image.draggable = false;
    image.addEventListener('contextmenu', (event) => event.preventDefault());
    image.addEventListener('dragstart', (event) => event.preventDefault());
    if (typeof blobOrUrl === 'string') {
      image.src = blobOrUrl;
    } else {
      const url = URL.createObjectURL(blobOrUrl);
      image.src = url;
      image.onload = () => URL.revokeObjectURL(url);
      image.onerror = () => {
        URL.revokeObjectURL(url);
        refs.vectorPreview.innerHTML = '<span>Aperçu indisponible</span>';
      };
    }
    refs.vectorPreview.appendChild(image);
  }

  function amptUploadFileName(preferredExt = 'png') {
    // Remove-bg only accepts PNG/JPEG. /images also accepts the SVG we already
    // vectorized when we ask for the matching production PDF.
    const raw = String(preferredExt || 'png').toLowerCase();
    const ext = raw === 'jpg' || raw === 'jpeg'
      ? 'jpg'
      : raw === 'svg'
        ? 'svg'
        : raw === 'pdf'
          ? 'pdf'
          : 'png';
    return `logo-editor.${ext}`;
  }

  function amptUploadExtForBlob(blob) {
    const type = String(blob?.type || '').toLowerCase();
    if (type.includes('svg')) return 'svg';
    if (type.includes('pdf')) return 'pdf';
    if (type.includes('jpeg') || type.includes('jpg')) return 'jpg';
    return 'png';
  }

  async function readAmptErrorMessage(response) {
    try {
      const text = await response.clone().text();
      if (!text) return '';
      try {
        const data = JSON.parse(text);
        if (typeof data?.message === 'string') return data.message;
        if (typeof data?.error === 'string') return data.error;
        if (data?.message && typeof data.message === 'object') {
          return Object.values(data.message).flat().join(', ');
        }
      } catch (error) {
        return text.slice(0, 160);
      }
      return text.slice(0, 160);
    } catch (error) {
      return '';
    }
  }

  function canvasToPngBlobFrom(sourceCanvas) {
    return new Promise((resolve, reject) => {
      sourceCanvas.toBlob((blob) => {
        if (!blob) reject(new Error('Export canvas impossible'));
        else resolve(blob);
      }, 'image/png');
    });
  }

  async function buildAmptUploadPngBlob() {
    // Always go through the imported stage pixels (PNG/JPEG/PDF/AI), never the raw
    // multi‑MB source file — that is what triggered Failed to fetch on ~5.6 Mo PNGs.
    let source = workCanvas;
    let blob = await canvasToPngBlobFrom(source);
    if (blob.size <= MAX_AMPT_UPLOAD_BYTES) return blob;

    const scale = Math.min(
      1,
      MAX_AMPT_UPLOAD_EDGE / Math.max(1, source.width, source.height),
      Math.sqrt(MAX_AMPT_UPLOAD_BYTES / Math.max(1, blob.size)),
    );
    if (scale < 0.999) {
      const scaled = document.createElement('canvas');
      scaled.width = Math.max(1, Math.round(source.width * scale));
      scaled.height = Math.max(1, Math.round(source.height * scale));
      const ctx = scaled.getContext('2d', { alpha: true });
      ctx.clearRect(0, 0, scaled.width, scaled.height);
      ctx.drawImage(source, 0, 0, scaled.width, scaled.height);
      source = scaled;
      blob = await canvasToPngBlobFrom(source);
    }

    // Last resort: JPEG (opaque bg) only if PNG is still too heavy for the gateway.
    if (blob.size > MAX_AMPT_UPLOAD_BYTES) {
      blob = await new Promise((resolve, reject) => {
        source.toBlob((next) => {
          if (!next) reject(new Error('Export canvas impossible'));
          else resolve(next);
        }, 'image/jpeg', 0.92);
      });
    }
    if (blob.size > MAX_AMPT_UPLOAD_BYTES) {
      throw new Error(`Image trop lourde pour l'IA (max ${Math.round(MAX_AMPT_UPLOAD_BYTES / (1024 * 1024))} Mo). Réduisez la taille puis réessayez.`);
    }
    return blob;
  }

  async function getRemoveBackgroundUploadFile() {
    const blob = await buildAmptUploadPngBlob();
    const ext = blob.type === 'image/jpeg' ? 'jpg' : 'png';
    return new File([blob], amptUploadFileName(ext), {
      type: blob.type || 'image/png',
    });
  }

  async function amptRemoveBackground(fileOrBlob) {
    const file = fileOrBlob instanceof File
      ? fileOrBlob
      : new File([fileOrBlob], amptUploadFileName('png'), { type: 'image/png' });
    const formData = new FormData();
    // Identical to remove_background.js: only the image file field.
    formData.append('image', file);
    let response;
    try {
      response = await fetch(`${creditConfig.apiBase}/remove-image-background`, {
        method: 'POST',
        body: formData,
      });
    } catch (error) {
      const msg = String(error?.message || error || '');
      if (/failed to fetch|networkerror|load failed/i.test(msg)) {
        throw new Error(`Connexion IA impossible (fichier trop lourd ou réseau). Max conseillé : ${Math.round(MAX_AMPT_UPLOAD_BYTES / (1024 * 1024))} Mo.`);
      }
      throw error;
    }
    if (!response.ok) {
      const detail = await readAmptErrorMessage(response);
      throw new Error(detail || `Suppression de fond impossible (${response.status})`);
    }
    const raw = await response.blob();
    if (!raw || !raw.size) throw new Error('Résultat de suppression de fond vide');
    const normalized = await sniffAmptImageBlob(raw, response.headers.get('content-type') || raw.type || 'image/png');
    if (normalized.kind !== 'raster') {
      throw new Error('Résultat de suppression de fond invalide');
    }
    return new File(
      [normalized.blob],
      amptUploadFileName('png'),
      { type: 'image/png' },
    );
  }

  async function amptVectorize(blob, maxColors = 50, fileFormat = 'png', mode = 'preview') {
    const formData = new FormData();
    formData.append('image', blob, amptUploadFileName(amptUploadExtForBlob(blob)));
    formData.append('mode', mode);
    formData.append('max_colors', String(maxColors || 50));
    formData.append('file_format', fileFormat);
    formData.append('customer_id', creditConfig.customerId || '');
    const response = await fetch(`${creditConfig.apiBase}/images`, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      const detail = await readAmptErrorMessage(response);
      throw new Error(detail || `Vectorisation impossible (${response.status})`);
    }
    const raw = await response.blob();
    if (fileFormat === 'pdf') {
      return raw.type ? raw : new Blob([raw], { type: 'application/pdf' });
    }
    return sniffAmptImageBlob(raw, response.headers.get('content-type') || '');
  }

  // Le fichier n'est un PDF que si l'en-tete le dit : l'API peut repondre une image
  // ou une erreur avec un code 200, et on telechargerait alors un .pdf illisible.
  async function isPdfBlob(blob) {
    const raw = blob instanceof Blob ? blob : (blob && blob.blob instanceof Blob ? blob.blob : null);
    if (!raw || !raw.size || typeof raw.slice !== 'function') return false;
    const head = new Uint8Array(await raw.slice(0, 16).arrayBuffer().catch(() => new ArrayBuffer(0)));
    let i = 0;
    if (head[0] === 0xef && head[1] === 0xbb && head[2] === 0xbf) i = 3;
    while (i < head.length && (head[i] === 0x20 || head[i] === 0x09 || head[i] === 0x0a || head[i] === 0x0d)) i += 1;
    return head[i] === 0x25 && head[i + 1] === 0x50 && head[i + 2] === 0x44 && head[i + 3] === 0x46;
  }

  function asPdfBlob(value) {
    if (value instanceof Blob) return value;
    if (value && value.blob instanceof Blob) return value.blob;
    return null;
  }

  async function fetchAmptProductionPdf(sourceBlob, maxColors) {
    if (!sourceBlob || !sourceBlob.size) return null;
    const pdfBlob = asPdfBlob(await amptVectorize(sourceBlob, maxColors, 'pdf', 'production'));
    if (!(await isPdfBlob(pdfBlob))) return null;
    return pdfBlob.type === 'application/pdf' ? pdfBlob : new Blob([pdfBlob], { type: 'application/pdf' });
  }

  function prefetchAmptProductionPdf(sourceBlob, maxColors) {
    const epoch = ++vectorPdfEpoch;
    const request = fetchAmptProductionPdf(sourceBlob, maxColors)
      .then((apiPdf) => {
        if (epoch !== vectorPdfEpoch) return null;
        if (apiPdf) state.vectorPdfBlob = apiPdf;
        return apiPdf;
      })
      .catch((error) => {
        console.warn('PDF production Ampt indisponible pendant la vectorisation', error);
        return null;
      });
    pendingVectorPdf = request;
    return request;
  }

  function vectorizedSvgBlob() {
    const svgText = String(state.vectorSvg || '');
    return svgText ? new Blob([svgText], { type: 'image/svg+xml' }) : null;
  }

  function printRasterPixelSize() {
    const widthCm = getPrintWidthCm();
    const heightCm = getPrintHeightCm();
    const widthPx = Math.max(1, Math.round((widthCm / CM_PER_INCH) * DPI));
    const heightPx = Math.max(1, Math.round((heightCm / CM_PER_INCH) * DPI));
    return { widthPx, heightPx };
  }

  async function rasterizeSvgIntoWorkCanvas(svgText, label, options = {}) {
    const geometry = readSvgGeometry(String(svgText || ''));
    const sourceW = Math.max(1, Math.round(geometry.width || workCanvas.width || 1024));
    const sourceH = Math.max(1, Math.round(geometry.height || workCanvas.height || 1024));
    // Keep a printable rasterization of the SVG without leaving a vector <img> on stage.
    const printSize = options.usePrintDpi ? printRasterPixelSize() : null;
    let width;
    let height;
    if (printSize) {
      const maxEdge = Math.min(MAX_OUTPUT_EDGE, Math.max(options.maxEdge || 4096, 1024));
      const scale = Math.min(1, maxEdge / Math.max(printSize.widthPx, printSize.heightPx));
      width = Math.max(1, Math.round(printSize.widthPx * scale));
      height = Math.max(1, Math.round(printSize.heightPx * scale));
    } else {
      const fallbackEdge = Math.max(workCanvas.width, workCanvas.height, 2048);
      const maxEdge = options.maxEdge || fallbackEdge;
      const scale = Math.min(1, maxEdge / Math.max(sourceW, sourceH));
      width = Math.max(1, Math.round(sourceW * scale));
      height = Math.max(1, Math.round(sourceH * scale));
    }
    const normalizedSvg = String(svgText).replace(
      /<svg\b([^>]*)>/i,
      (match, attrs) => {
        let next = attrs
          .replace(/\swidth=(['"]).*?\1/i, '')
          .replace(/\sheight=(['"]).*?\1/i, '');
        if (!/\sviewBox=/i.test(next) && geometry.width && geometry.height) {
          next += ` viewBox="${geometry.x || 0} ${geometry.y || 0} ${geometry.width} ${geometry.height}"`;
        }
        return `<svg${next} width="${width}" height="${height}">`;
      },
    );
    const svgBlob = new Blob([normalizedSvg], { type: 'image/svg+xml' });
    await loadBlobIntoWorkCanvas(svgBlob, label, options);
  }

  async function buildVectorPdfBlobForApply() {
    if (!(state.vectorExportReady || state.vectorSvg)) return null;
    try {
      return await resolveAmptVectorPdf();
    } catch (error) {
      console.warn('Ampt vector PDF for apply failed', error);
      return null;
    }
  }

  async function consumeDownloadCredit() {
    if (!creditConfig.required) return true;

    if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
      redirectToLogin();
      return false;
    }

    if (hasFreeDownloadAvailable()) {
      markFreeDownloadUsed();
      showToast('Téléchargement test gratuit utilisé', 'good');
      updateCreditUI();
      updateInterface();
      return true;
    }

    if (!state.creditsReady) {
      await refreshCredits();
    }

    if (!state.creditsReady) {
      showToast('Verification des credits impossible', 'error');
      return false;
    }

    if (state.creditsReady && Number(state.creditsBalance) <= 0) {
      redirectToBuyCredits();
      return false;
    }

    const beforeBalance = Number(state.creditsBalance);
    const previousStatus = refs.operationStatus.textContent || 'Pret';
    state.creditsConsuming = true;
    refs.operationStatus.textContent = 'Verification credit';
    setStageLoading(true, 'Verification des credits', '1 credit par telechargement');
    updateInterface();

    try {
      const response = await fetch(`${creditConfig.ledgerBase}/credit/use`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: creditConfig.customerId }),
      });

      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) redirectToBuyCredits();
        else showToast('Verification des credits impossible', 'error');
        return false;
      }

      const data = await response.json().catch(() => ({}));
      const responseBalance = parseCreditBalance(data.balance ?? data);
      applyConsumedCreditBalance(beforeBalance, responseBalance);
      showToast('1 crédit consommé', 'good');
      return true;
    } catch (error) {
      console.warn('Credit use failed:', error);
      showToast('Verification des credits impossible', 'error');
      return false;
    } finally {
      state.creditsConsuming = false;
      setStageLoading(false);
      if (refs.operationStatus.textContent === 'Verification credit') {
        refs.operationStatus.textContent = previousStatus;
      }
      updateInterface();
    }
  }

  async function confirmDownloadCredit(formatLabel) {
    if (!creditConfig.required) return true;

    if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
      redirectToLogin();
      return false;
    }

    await refreshCredits();

    if (!state.creditsReady) {
      showToast('Verification des credits impossible', 'error');
      return false;
    }

    const balance = Number(state.creditsBalance) || 0;
    const freeDownloadAvailable = hasFreeDownloadAvailable();
    if (balance <= 0 && !freeDownloadAvailable) {
      redirectToBuyCredits();
      return false;
    }

    if (!refs.creditModal) {
      return window.confirm(
        freeDownloadAvailable
          ? 'Votre premier téléchargement est offert. Aucun crédit ne sera consommé. Après cet essai gratuit, 1 crédit sera nécessaire pour télécharger.'
          : 'Ce téléchargement PDF va consommer 1 crédit.'
      );
    }

    refs.creditModalTitle.textContent = `Télécharger le ${formatLabel}`;
    refs.creditModalText.textContent = freeDownloadAvailable
      ? 'Votre premier téléchargement est offert. Aucun crédit ne sera consommé.'
      : 'Ce téléchargement PDF va consommer 1 crédit.';
    refs.creditModalBalance.textContent = freeDownloadAvailable
      ? 'Après cet essai gratuit, 1 crédit sera nécessaire pour télécharger vos prochains fichiers.'
      : `Crédits disponibles : ${balance}. Après téléchargement : ${Math.max(0, balance - 1)}.`;
    if (refs.creditModalConfirm) {
      refs.creditModalConfirm.textContent = freeDownloadAvailable
        ? 'Télécharger gratuitement'
        : 'Télécharger et utiliser 1 crédit';
    }
    refs.creditModal.hidden = false;
    document.body.classList.add('le-credit-modal-open');
    refs.creditModalConfirm?.focus();

    return new Promise((resolve) => {
      creditModalResolve = resolve;
    });
  }

  function closeCreditModal(confirmed) {
    if (refs.creditModal) refs.creditModal.hidden = true;
    document.body.classList.remove('le-credit-modal-open');
    if (creditModalResolve) {
      creditModalResolve(Boolean(confirmed));
      creditModalResolve = null;
    }
  }

  function updateCreditUI() {
    if (!refs.creditPill) return;

    if (!creditConfig.required) {
      refs.creditPill.hidden = true;
      return;
    }

    const balance = Math.max(0, Number(state.creditsBalance) || 0);
    const freeDownloadAvailable = hasFreeDownloadAvailable();

    refs.creditPill.hidden = false;
    refs.creditPill.classList.toggle('is-loading', state.creditsLoading || state.creditsConsuming);
    refs.creditPill.classList.toggle('is-empty', state.creditsReady && !freeDownloadAvailable && balance <= 0);
    refs.creditPill.classList.toggle('is-good', freeDownloadAvailable || (state.creditsReady && balance > 0));

    if (!creditConfig.isLoggedIn) {
      refs.creditLabel.textContent = 'Connexion requise';
      refs.creditCount.textContent = '-';
      return;
    }

    if (state.creditsLoading && !state.creditsReady) {
      refs.creditLabel.textContent = 'Crédits';
      refs.creditCount.textContent = '...';
      return;
    }

    if (!state.creditsReady) {
      refs.creditLabel.textContent = 'Crédits';
      refs.creditCount.textContent = '?';
      return;
    }

    if (freeDownloadAvailable) {
      refs.creditLabel.textContent = 'Essai gratuit';
      refs.creditCount.textContent = '1';
      return;
    }

    refs.creditLabel.textContent = balance > 1 ? 'Crédits' : 'Crédit';
    refs.creditCount.textContent = String(balance);
  }

  function redirectToBuyCredits() {
    showToast("Vous n'avez plus de crédits", 'error');
    window.setTimeout(() => {
      window.location.assign(creditConfig.buyUrl);
    }, 450);
  }

  function redirectToLogin() {
    showToast('Connectez-vous pour télécharger', 'error');
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
    window.setTimeout(() => {
      window.location.assign(`/account/login?return_url=${returnUrl}`);
    }, 450);
  }

  function render() {
    if (!hasImage()) {
      refs.previewCanvas.classList.remove('is-visible', 'is-cropping');
      refs.vectorStage.classList.remove('is-visible');
      refs.stageStack?.classList.remove('is-visible');
      refs.canvasZone.classList.remove('has-image', 'is-panning');
      setStageLoading(false);
      refs.emptyState.hidden = false;
      updateInterface();
      return;
    }

    refs.emptyState.hidden = true;
    const displayWidth = `${Math.max(1, Math.round(workCanvas.width * state.zoom))}px`;
    const displayHeight = `${Math.max(1, Math.round(workCanvas.height * state.zoom))}px`;
    refs.previewCanvas.style.width = displayWidth;
    refs.previewCanvas.style.height = displayHeight;
    if (refs.stageStack) {
      refs.stageStack.style.width = displayWidth;
      refs.stageStack.style.height = displayHeight;
      refs.stageStack.classList.add('is-visible');
    }

    const useVectorPreview = Boolean(state.vectorExportReady && state.vectorSvg && !state.crop);
    if (useVectorPreview) {
      // True SVG on stage — stays sharp when zooming. Canvas kept only for tools/export helpers.
      showVectorStagePreview();
      refs.previewCanvas.classList.remove('is-visible', 'is-cropping');
    } else {
      hideVectorStage();
      refs.previewCanvas.width = workCanvas.width;
      refs.previewCanvas.height = workCanvas.height;
      previewCtx.clearRect(0, 0, workCanvas.width, workCanvas.height);
      previewCtx.drawImage(workCanvas, 0, 0);
      if (state.crop) drawCropOverlay(previewCtx);
      refs.previewCanvas.classList.add('is-visible');
      refs.previewCanvas.classList.toggle('is-cropping', Boolean(state.crop));
    }

    refs.canvasZone.classList.toggle('has-image', true);
    updateInterface();
  }

  function drawCropOverlay(ctx) {
    const { x, y, w, h } = state.crop.rect;
    const cw = workCanvas.width;
    const ch = workCanvas.height;
    const hs = getHandleSize();

    ctx.save();
    ctx.fillStyle = 'rgba(17, 24, 39, .48)';
    ctx.fillRect(0, 0, cw, y);
    ctx.fillRect(0, y + h, cw, ch - y - h);
    ctx.fillRect(0, y, x, h);
    ctx.fillRect(x + w, y, cw - x - w, h);

    ctx.strokeStyle = '#2563eb';
    ctx.lineWidth = Math.max(1, 2 / state.zoom);
    ctx.strokeRect(x, y, w, h);

    ctx.fillStyle = '#fff';
    ctx.strokeStyle = '#2563eb';
    cropHandles(state.crop.rect).forEach((handle) => {
      ctx.beginPath();
      ctx.rect(handle.x - hs / 2, handle.y - hs / 2, hs, hs);
      ctx.fill();
      ctx.stroke();
    });
    ctx.restore();
  }

  function updateInterface() {
    const loaded = hasImage();
    const isVector = isVectorFile();
    const busy = state.isBusy || state.creditsConsuming;
    const sizeText = loaded ? `${workCanvas.width} x ${workCanvas.height} px` : '0 x 0 px';
    if (refs.uploadTitle) refs.uploadTitle.textContent = loaded ? 'Fichier' : 'Upload';
    refs.fileState.textContent = loaded ? state.fileKind : 'Aucun';
    refs.fileCard.hidden = !loaded;
    if (refs.dropzone) refs.dropzone.hidden = loaded;
    if (refs.fileSection) refs.fileSection.classList.toggle('has-file', loaded);
    if (refs.canvasZone) refs.canvasZone.classList.toggle('is-import-ready', !loaded);
    refs.fileName.textContent = loaded ? state.fileName : '';
    refs.fileMeta.textContent = loaded ? sizeText : '';
    refs.statusSize.textContent = sizeText;
    refs.statusPrint.textContent = loaded ? formatPrintSize(getPrintWidthCm(), getPrintHeightCm()) : '0 x 0 cm';
    if (refs.dimensionsDpi) {
      refs.dimensionsDpi.textContent = !loaded
        ? 'En attente'
        : isVectorFile()
          ? 'Vectoriel'
          : `${getEffectiveDpi()} DPI`;
    }
    refs.statusColors.textContent = `${state.palette.length} couleur${state.palette.length > 1 ? 's' : ''}`;
    if (refs.colorCount) refs.colorCount.textContent = String(state.palette.length);
    refs.zoomLabel.textContent = `${Math.round(state.zoom * 100)}%`;
    if (refs.upscaleStatus) {
      refs.upscaleStatus.textContent = isVector
        ? 'Vectoriel'
        : refs.upscaleEngine?.value === 'local'
        ? 'Local'
        : state.upscalerReady ? 'IA prete' : 'IA auto';
    }
    if (refs.upscaleFactor) refs.upscaleFactor.disabled = !loaded || busy || isVector;
    if (refs.upscaleEngine) refs.upscaleEngine.disabled = !loaded || busy || isVector;
    if (refs.upscalePanel) refs.upscalePanel.classList.toggle('is-disabled', isVector);
    if (refs.cropStatus) refs.cropStatus.textContent = state.crop ? 'Actif' : 'Libre';
    if (refs.bgStatus) refs.bgStatus.textContent = loaded && hasTransparentPixels() ? 'Transparent' : 'Fond detecte';
    updateCreditUI();
    updateQualityPanel(loaded);
    if (refs.zoneLayerThin) refs.zoneLayerThin.disabled = !loaded || busy;
    if (refs.zoneLayerSemi) refs.zoneLayerSemi.disabled = !loaded || busy;

    $$('[data-action]').forEach((button) => {
      const action = button.dataset.action;
      if (['undo', 'redo'].includes(action)) return;
      if (action === 'close-editor' || action === 'close-zones') {
        button.disabled = false;
        return;
      }
      if (action === 'see-zones') {
        button.disabled = !loaded || busy || maestroProblemZones().length === 0;
        return;
      }
      if (action === 'retry-maestro') {
        button.disabled = !loaded || busy || state.maestroValidating;
        return;
      }
      if (action === 'pick-file') {
        button.disabled = loaded || busy;
        return;
      }
      if (['reset', 'fit', 'zoom-in', 'zoom-out'].includes(action)) return;
      if (action === 'download-pdf' || action === 'apply-to-host' || action === 'save-library') {
        button.disabled = !loaded || busy;
        return;
      }
      if (action === 'upscale') {
        button.disabled = !loaded || busy || isVector;
        button.title = isVector ? 'Amelioration desactivee sur une version vectorielle' : '';
        return;
      }
      if (action === 'vectorize') {
        const offer = needsVectorize();
        button.disabled = !loaded || busy || !offer;
        button.title = !offer ? 'Fichier déjà vectoriel ou résolution suffisante' : '';
        return;
      }
      if (action === 'remove-bg') {
        const offer = needsRemoveBackground();
        button.disabled = !loaded || busy || !offer;
        button.title = !offer ? 'Aucun fond à retirer' : '';
        return;
      }
      if (action === 'trim') {
        const offer = needsTrimWhitespace();
        button.disabled = !loaded || busy || !offer;
        button.title = !offer ? 'Aucun espace vide à retirer' : '';
        return;
      }
      if (action === 'remove-semi-transparency') {
        const offer = needsCleanSemi();
        button.disabled = !loaded || busy || !offer;
        button.title = !offer ? 'Aucune semi-transparence à nettoyer' : '';
        return;
      }
      if (['apply-crop', 'cancel-crop'].includes(action)) {
        button.disabled = !loaded || !state.crop || busy;
        return;
      }
      button.disabled = !loaded || busy;
    });

    $('[data-action="undo"]').disabled = state.history.length <= 1 || busy;
    $('[data-action="redo"]').disabled = state.redo.length === 0 || busy;

    if (loaded) {
      updateResizeInputs();
      updateThumb();
    }

    renderColorList();
  }

  function updateRangeLabels() {
    if (refs.semiThresholdLabel && refs.semiThreshold) refs.semiThresholdLabel.textContent = refs.semiThreshold.value;
    if (refs.textileToleranceLabel && refs.textileTolerance) refs.textileToleranceLabel.textContent = refs.textileTolerance.value;
    if (refs.colorToleranceLabel && refs.colorTolerance) refs.colorToleranceLabel.textContent = refs.colorTolerance.value;
    if (refs.resizeScaleLabel && refs.resizeScale) refs.resizeScaleLabel.textContent = `${refs.resizeScale.value}%`;
    if (refs.adjustBrightnessLabel && refs.adjustBrightness) refs.adjustBrightnessLabel.textContent = refs.adjustBrightness.value;
    if (refs.adjustContrastLabel && refs.adjustContrast) refs.adjustContrastLabel.textContent = refs.adjustContrast.value;
    if (refs.adjustSaturationLabel && refs.adjustSaturation) refs.adjustSaturationLabel.textContent = refs.adjustSaturation.value;
  }

  function updateResizeInputs() {
    if (!hasImage() || state.inputLock) return;
    ensurePrintSize();
    state.inputLock = true;
    refs.resizeWidth.value = formatCmInput(state.printWidthCm);
    refs.resizeHeight.value = formatCmInput(state.printHeightCm);
    refs.resizeScale.value = '100';
    refs.resizeScaleLabel.textContent = '100%';
    state.inputLock = false;
  }

  function updatePairedResizeInput(changed) {
    if (!hasImage() || state.inputLock || !refs.lockRatio.checked) return;
    const ratio = workCanvas.width / workCanvas.height;
    state.inputLock = true;
    if (changed === 'width') {
      const widthCm = toPositiveNumber(refs.resizeWidth.value, getPrintWidthCm());
      refs.resizeHeight.value = formatCmInput(widthCm / ratio);
    } else {
      const heightCm = toPositiveNumber(refs.resizeHeight.value, getPrintHeightCm());
      refs.resizeWidth.value = formatCmInput(heightCm * ratio);
    }
    state.inputLock = false;
  }

  function updateResizeInputsFromScale() {
    if (!hasImage() || state.inputLock) return;
    const scale = Number(refs.resizeScale.value) / 100;
    state.inputLock = true;
    refs.resizeWidth.value = formatCmInput(getPrintWidthCm() * scale);
    refs.resizeHeight.value = formatCmInput(getPrintHeightCm() * scale);
    state.inputLock = false;
  }

  function setQualityBusy(active) {
    if (refs.qualityPanel) refs.qualityPanel.classList.toggle('is-checking', active);
    if (refs.qualityBusy) refs.qualityBusy.hidden = !active;
  }

  function updateQualityPanel(loaded) {
    if (!refs.qualityOverall) return;
    const metricKeys = ['dpi', 'size', 'whitespace', 'semi', 'transparent', 'thin', 'colors'];
    setQualityBusy(Boolean(loaded && state.maestroValidating));

    if (!loaded) {
      refs.qualityOverall.textContent = 'En attente';
      if (refs.qualityScore) {
        refs.qualityScore.textContent = '––/100';
        refs.qualityScore.classList.remove('is-good', 'is-warn', 'is-bad');
      }
      metricKeys.forEach((key) => setQualityMetric(key, 'En attente', 'empty'));
      if (refs.seeZones) refs.seeZones.hidden = true;
      if (refs.retryMaestro) refs.retryMaestro.hidden = true;
      closeMaestroZones();
      updateZoneToggles();
      updateDrawerRecommendations(null);
      return;
    }

    if (state.maestroValidating && !hasMaestroResult()) {
      refs.qualityOverall.textContent = 'Contrôle en cours';
      if (refs.qualityScore) {
        refs.qualityScore.textContent = '––/100';
        refs.qualityScore.classList.remove('is-good', 'is-warn', 'is-bad');
      }
    }

    if (!state.qualityCache) state.qualityCache = analyzeLogoQuality();
    const quality = state.qualityCache;
    const alerts = hasMaestroResult() ? maestroAlerts() : null;
    const hasSemi = alerts ? alerts.semi : false;
    const hasThin = alerts ? alerts.thin : false;
    const hasBackground = alerts ? alerts.background : !quality.transparentBackground;
    const hasResolutionIssue = alerts ? alerts.resolution : (!isVectorFile() && quality.dpi < DPI);
    const issues = collectQualityIssues(quality);
    const bad = issues.filter((item) => item.level === 'bad').length;
    const warn = issues.filter((item) => item.level === 'warn').length;
    const score = Math.max(0, 100 - bad * 28 - warn * 12);
    const tone = !hasMaestroResult()
      ? (state.maestroValidating ? '' : 'bad')
      : bad ? 'bad' : warn ? 'warn' : 'good';
    const label = state.maestroValidating && !hasMaestroResult()
      ? 'Contrôle en cours'
      : !hasMaestroResult()
        ? (state.maestroError || 'Vérification incomplète')
        : bad ? 'À corriger' : warn ? 'À améliorer' : 'Prêt pour impression';

    refs.qualityOverall.textContent = label;
    if (refs.qualityScore) {
      refs.qualityScore.classList.remove('is-good', 'is-warn', 'is-bad');
      if (!hasMaestroResult()) {
        refs.qualityScore.textContent = '––/100';
      } else {
        refs.qualityScore.textContent = score + '/100';
        refs.qualityScore.classList.add('is-' + tone);
      }
    }

    if (isVectorFile() && !hasResolutionIssue) {
      setQualityMetric('dpi', 'Fichier vectoriel', 'good');
    } else {
      // La pastille suit le verdict de la verification : un DPI local suffisant ne
      // doit pas s'afficher en vert quand l'API signale la resolution.
      setQualityMetric('dpi', quality.dpi + ' DPI', hasResolutionIssue ? (quality.dpi < 150 ? 'bad' : 'warn') : 'good');
    }
    setQualityMetric('size', formatPrintSize(quality.printWidthCm, quality.printHeightCm), 'good');

    // Marge vide : information de cadrage, pas un defaut — sans incidence sur le score.
    if (!quality.hasContent) setQualityMetric('whitespace', 'Logo non detecte', 'bad');
    else if (quality.hasWhitespace) setQualityMetric('whitespace', 'Oui (' + formatRatioPercent(quality.whitespaceRatio) + ')', 'empty');
    else setQualityMetric('whitespace', 'Non', 'good');

    const maestroPending = state.maestroValidating && !alerts;
    const maestroMissing = !alerts && !state.maestroValidating;
    const maestroTone = maestroPending || maestroMissing ? 'empty' : 'good';
    const maestroLabel = maestroPending
      ? 'Contrôle en cours'
      : maestroMissing
        ? (state.maestroError ? 'Échec' : 'Indisponible')
        : '';

    if (!alerts) setQualityMetric('semi', maestroLabel, maestroTone);
    else if (hasSemi) setQualityMetric('semi', 'Oui', 'warn');
    else setQualityMetric('semi', 'Non', 'good');

    if (!hasBackground) setQualityMetric('transparent', 'Transparent', 'good');
    else if (!alerts && quality.backgroundStatus === 'partial') setQualityMetric('transparent', 'Partiel', 'warn');
    else setQualityMetric('transparent', alerts ? 'Fond détecté' : 'Fond opaque', 'warn');

    if (!alerts) setQualityMetric('thin', maestroLabel, maestroTone);
    else if (hasThin) setQualityMetric('thin', 'Oui', 'warn');
    else setQualityMetric('thin', 'Non', 'good');

    if (!alerts) setQualityMetric('colors', maestroLabel || '—', maestroTone);
    else if (alerts.colors) setQualityMetric('colors', 'Tons directs', 'warn');
    else setQualityMetric('colors', 'OK', 'good');

    if (refs.seeZones) refs.seeZones.hidden = true;
    if (refs.retryMaestro) refs.retryMaestro.hidden = state.maestroValidating || !maestroMissing;
    updateZoneToggles();

    updateDrawerRecommendations(quality);
  }

  function updateDrawerRecommendations(quality) {
    const alerts = hasMaestroResult() ? maestroAlerts() : null;
    const flags = {
      vectorize: needsVectorize(),
      removeBg: needsRemoveBackground(),
      semi: needsCleanSemi(),
      colors: Boolean(alerts && alerts.colors),
      adjust: false,
      crop: needsTrimWhitespace(),
    };
    const doneLabels = {
      vectorize: isVectorFile() ? 'Fichier déjà vectorisé' : '',
      removeBg: quality && quality.hasContent && !needsRemoveBackground()
        ? 'Fond déjà transparent'
        : '',
    };

    Object.entries(refs.drawers || {}).forEach(([key, drawer]) => {
      if (!drawer) return;
      const recommended = Boolean(flags[key]);
      const doneLabel = doneLabels[key] || '';
      const badge = drawer.querySelector('[data-reco-badge]');
      const doneBadge = drawer.querySelector('[data-done-badge]');
      drawer.classList.toggle('is-recommended', recommended);
      drawer.classList.toggle('is-already-done', Boolean(doneLabel) && !recommended);
      if (badge) {
        badge.hidden = !recommended;
        badge.textContent = 'Reco';
      }
      if (doneBadge) {
        doneBadge.hidden = recommended || !doneLabel;
        if (doneLabel) doneBadge.textContent = doneLabel;
      }
    });
  }

  function pulseSizePanel() {
    if (!refs.sizePanel) return;
    refs.sizePanel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    refs.sizePanel.classList.remove('is-attention');
    void refs.sizePanel.offsetWidth;
    refs.sizePanel.classList.add('is-attention');
    window.clearTimeout(pulseSizePanel._timer);
    pulseSizePanel._timer = window.setTimeout(() => {
      refs.sizePanel?.classList.remove('is-attention');
    }, 4200);
  }

  function collectQualityIssues(quality) {
    const issues = [];
    const alerts = hasMaestroResult() ? maestroAlerts() : null;
    if (!quality.hasContent) issues.push({ level: 'bad' });
    if (alerts) {
      if (alerts.resolution) issues.push({ level: quality.dpi < 150 ? 'bad' : 'warn' });
      if (alerts.background) issues.push({ level: 'warn' });
      if (alerts.semi) issues.push({ level: 'warn' });
      if (alerts.thin) issues.push({ level: 'warn' });
      if (alerts.colors) issues.push({ level: 'warn' });
    } else {
      if (!isVectorFile()) {
        if (quality.dpi < 150) issues.push({ level: 'bad' });
        else if (quality.dpi < DPI) issues.push({ level: 'warn' });
      }
      if (!quality.transparentBackground) issues.push({ level: 'warn' });
    }
    return issues;
  }

  function analyzeThinAreas(mask, width, height, dpi) {
    const thinMm = 0.35;
    const pxPerMm = isVectorFile()
      ? width / Math.max(1, getPrintWidthCm() * 10)
      : Math.max(1, (dpi || DPI) / 25.4);
    const threshold = Math.max(1, Math.round(thinMm * pxPerMm));
    let content = 0;
    let thin = 0;
    for (let y = 0; y < height; y += 1) {
      let runStart = -1;
      for (let x = 0; x <= width; x += 1) {
        const visible = x < width && mask[y * width + x];
        if (visible && runStart < 0) runStart = x;
        if ((!visible || x === width) && runStart >= 0) {
          const run = x - runStart;
          content += run;
          if (run <= threshold) thin += run;
          runStart = -1;
        }
      }
    }
    for (let x = 0; x < width; x += 1) {
      let runStart = -1;
      for (let y = 0; y <= height; y += 1) {
        const visible = y < height && mask[y * width + x];
        if (visible && runStart < 0) runStart = y;
        if ((!visible || y === height) && runStart >= 0) {
          const run = y - runStart;
          if (run <= threshold) thin += run;
          runStart = -1;
        }
      }
    }
    const ratio = content ? thin / (content * 2) : 0;
    return { hasThinAreas: ratio > 0.012, ratio, thresholdMm: thinMm };
  }

  function setQualityMetric(key, value, tone) {
    const item = refs.qualityItems[key];
    const label = refs.qualityValues[key];
    if (!item || !label) return;
    label.textContent = value;
    item.classList.remove('is-good', 'is-warn', 'is-bad', 'is-empty');
    item.classList.add(`is-${tone}`);
  }

  function analyzeLogoQuality() {
    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    const total = w * h;
    const maxSamples = 9000000;
    const stride = total > maxSamples ? Math.ceil(Math.sqrt(total / maxSamples)) : 1;
    const edgeStats = analyzeTransparentEdges(data, w, h, stride);
    const transparentBackground = edgeStats.samples > 0 && edgeStats.transparent / edgeStats.samples > 0.08;
    const bg = edgeAverageColor(data, w, h);
    const tolerance = 44;
    const totalPixels = w * h;
    const mask = new Uint8Array(totalPixels);
    let sampled = 0;
    let transparentPixels = 0;
    let semiPixels = 0;
    let contentPixels = 0;
    let minX = w;
    let minY = h;
    let maxX = -1;
    let maxY = -1;
    const colorSet = new Set();
    const colorStep = Math.max(1, Math.floor(totalPixels / 30000));
    const edgeOpaqueRatio = edgeStats.samples > 0 ? edgeStats.opaque / edgeStats.samples : 0;

    for (let y = 0; y < h; y += stride) {
      for (let x = 0; x < w; x += stride) {
        const p = y * w + x;
        const idx = p * 4;
        const alpha = data[idx + 3];
        sampled += 1;
        if (alpha < 8) transparentPixels += 1;
        if (alpha > 8 && alpha < 245) semiPixels += 1;

        const visible = transparentBackground
          ? alpha > 10
          : alpha > 10 && colorDistanceAt(data, idx, bg) > tolerance;
        if (!visible) continue;
        mask[p] = 1;
        contentPixels += 1;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (p % colorStep === 0) {
          colorSet.add((data[idx] >> 4) + '-' + (data[idx + 1] >> 4) + '-' + (data[idx + 2] >> 4));
        }
      }
    }

    const hasContent = maxX >= minX && maxY >= minY;
    const bounds = hasContent
      ? { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 }
      : null;
    const whitespaceRatio = bounds ? clamp(1 - (bounds.w * bounds.h) / (w * h), 0, 1) : 1;
    const hasWhitespace = Boolean(bounds)
      && whitespaceRatio > 0.015
      && (bounds.x > 3 || bounds.y > 3 || bounds.x + bounds.w < w - 3 || bounds.y + bounds.h < h - 3);
    const dpi = getEffectiveDpi();
    const thin = analyzeThinAreas(mask, w, h, dpi);
    const backgroundStatus = transparentBackground ? 'none' : (edgeOpaqueRatio > 0.86 ? 'solid' : 'partial');
    const complex = colorSet.size > 42 || thin.hasThinAreas || contentPixels / Math.max(1, sampled) > 0.72;

    return {
      dpi,
      width: w,
      height: h,
      printWidthCm: getPrintWidthCm(),
      printHeightCm: getPrintHeightCm(),
      hasContent,
      hasWhitespace,
      whitespaceRatio,
      transparentBackground,
      backgroundStatus,
      transparentPixels,
      transparentRatio: sampled ? transparentPixels / sampled : 0,
      semiPixels,
      semiRatio: sampled ? semiPixels / sampled : 0,
      hasSemiTransparency: sampled ? (semiPixels / sampled) > 0.001 : false,
      thin,
      complex,
      colorCount: colorSet.size,
    };
  }

  function analyzeTransparentEdges(data, width, height, stride) {
    let samples = 0;
    let transparent = 0;
    let opaque = 0;
    const step = Math.max(1, stride);
    const add = (x, y) => {
      const idx = (y * width + x) * 4;
      samples += 1;
      if (data[idx + 3] < 8) transparent += 1;
      else if (data[idx + 3] >= 245) opaque += 1;
    };

    for (let x = 0; x < width; x += step) {
      add(x, 0);
      add(x, height - 1);
    }
    for (let y = 0; y < height; y += step) {
      add(0, y);
      add(width - 1, y);
    }

    return { samples, transparent, opaque };
  }

  function updateThumb() {
    const canvas = refs.thumbCanvas;
    const ctx = canvas.getContext('2d');
    const boxW = 108;
    const boxH = 88;
    canvas.width = boxW;
    canvas.height = boxH;
    ctx.clearRect(0, 0, boxW, boxH);
    const scale = Math.min(boxW / workCanvas.width, boxH / workCanvas.height);
    const w = workCanvas.width * scale;
    const h = workCanvas.height * scale;
    ctx.drawImage(workCanvas, (boxW - w) / 2, (boxH - h) / 2, w, h);
  }

  function onCanvasWheel(event) {
    if (!hasImage()) return;
    const stage = currentStageElement();
    if (!stage) return;
    event.preventDefault();

    const rect = stage.getBoundingClientRect();
    const zoneRect = refs.canvasZone.getBoundingClientRect();
    const pointX = clamp((event.clientX - rect.left) / Math.max(1, rect.width), 0, 1);
    const pointY = clamp((event.clientY - rect.top) / Math.max(1, rect.height), 0, 1);
    const nextZoom = state.zoom * (event.deltaY > 0 ? 0.88 : 1.14);
    setZoom(nextZoom);

    window.requestAnimationFrame(() => {
      const nextStage = currentStageElement();
      if (!nextStage) return;
      refs.canvasZone.scrollLeft = nextStage.offsetLeft + pointX * nextStage.offsetWidth - (event.clientX - zoneRect.left);
      refs.canvasZone.scrollTop = nextStage.offsetTop + pointY * nextStage.offsetHeight - (event.clientY - zoneRect.top);
    });
  }

  function currentStageElement() {
    if (state.vectorSvg && refs.vectorStage.classList.contains('is-visible')) return refs.vectorStage;
    if (refs.previewCanvas.classList.contains('is-visible')) return refs.previewCanvas;
    return null;
  }

  function setZoom(nextZoom) {
    if (!hasImage()) return;
    state.zoom = clamp(nextZoom, 0.04, 12);
    render();
  }

  function fitToView(shouldRender = true) {
    if (!hasImage()) return;
    const rect = refs.canvasZone.getBoundingClientRect();
    const fit = Math.min((rect.width - 72) / workCanvas.width, (rect.height - 72) / workCanvas.height, 1.5);
    state.zoom = clamp(Number.isFinite(fit) ? fit : 1, 0.04, 1.5);
    if (shouldRender) render();
  }

  function setBusy(status) {
    state.isBusy = status && status !== 'Pret';
    refs.operationStatus.textContent = status || 'Pret';
    updateInterface();
  }

  function setStageLoading(active, title = '', detail = '') {
    if (!refs.stageLoader) return;
    refs.stageLoader.hidden = !active;
    if (title) refs.stageLoaderTitle.textContent = title;
    if (detail) refs.stageLoaderDetail.textContent = detail;
  }

  function pushHistory(label, options = {}) {
    if (!hasImage()) return;
    state.history.push({
      label,
      dataUrl: workCanvas.toDataURL('image/png'),
      width: workCanvas.width,
      height: workCanvas.height,
      printWidthCm: getPrintWidthCm(),
      printHeightCm: getPrintHeightCm(),
      fileName: state.fileName,
      fileKind: state.fileKind,
    });
    if (state.history.length > 24) state.history.shift();
    state.redo = [];
    state.qualityCache = null;
    if (!options.preserveVectorExport) {
      clearVector();
    }
  }

  async function undo() {
    if (state.history.length <= 1) return;
    const current = state.history.pop();
    state.redo.push(current);
    await restoreSnapshot(state.history[state.history.length - 1]);
  }

  async function redo() {
    if (!state.redo.length) return;
    const snap = state.redo.pop();
    state.history.push(snap);
    await restoreSnapshot(snap);
  }

  async function restoreSnapshot(snapshot) {
    const image = await loadImage(snapshot.dataUrl);
    workCanvas.width = snapshot.width;
    workCanvas.height = snapshot.height;
    workCtx.clearRect(0, 0, workCanvas.width, workCanvas.height);
    workCtx.drawImage(image, 0, 0);
    state.fileName = snapshot.fileName;
    state.fileKind = snapshot.fileKind;
    state.printWidthCm = snapshot.printWidthCm || pxToCmNumber(snapshot.width);
    state.printHeightCm = snapshot.printHeightCm || pxToCmNumber(snapshot.height);
    state.crop = null;
    state.pan = null;
    state.qualityCache = null;
    clearVector();
    detectPalette();
    render();
  }

  function sampleBackgroundFromEdges(announce = true) {
    if (!withImage() || !refs.bgColor) return;
    const data = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height).data;
    const color = edgeAverageColor(data, workCanvas.width, workCanvas.height);
    refs.bgColor.value = rgbToHex(color);
    if (announce) showToast('Couleur de fond mise a jour');
  }

  async function removeBackground() {
    if (!withImage()) return;
    if (!needsRemoveBackground()) {
      showToast('Aucun fond à retirer', 'good');
      return;
    }
    setBusy('Retrait du fond IA');
    setStageLoading(true, 'Suppression de fond', 'Traitement IA');
    try {
      // Any previous vector/PDF source still contains the old background — drop it first.
      clearVector();
      hideVectorStage();

      const uploadFile = await getRemoveBackgroundUploadFile();
      const resultFile = await amptRemoveBackground(uploadFile);
      const resultCanvas = await decodeBlobToCanvas(resultFile);

      // Apply Ampt pixels immediately (same result the product page downloads).
      // Credits are charged only on PDF download, not on AI preview tools.
      clearVector();
      state.vectorSourceBlob = null;
      state.uploadFile = resultFile;
      commitCanvasResult(resultCanvas, 'Fond retire (IA)');
      trimWhitespace(true, false);
      state.qualityCache = null;
      state.vectorSourceBlob = null;
      fitToView(false);
      paintRasterStage();
      render();
      if (refs.bgStatus) refs.bgStatus.textContent = 'Transparent';
      showToast('Fond retire', 'good');
    } catch (error) {
      console.error(error);
      showToast(error.message || 'Suppression de fond impossible', 'error');
    } finally {
      setStageLoading(false);
      setBusy('Pret');
      paintRasterStage();
      render();
    }
  }

  function clearPixelByDistance(data, idx, bg, tolerance, feather) {
    const alpha = data[idx + 3];
    if (alpha <= 0) return 0;
    const distance = colorDistanceAt(data, idx, bg);
    if (distance <= tolerance) {
      if (alpha) data[idx + 3] = 0;
      return 1;
    }
    if (feather > 0 && distance <= tolerance + feather) {
      const keep = (distance - tolerance) / feather;
      const nextAlpha = Math.max(0, Math.round(alpha * keep));
      if (nextAlpha < alpha) {
        data[idx + 3] = nextAlpha;
        return 1;
      }
    }
    return 0;
  }

  function removeTextileColor() {
    if (!withImage()) return;
    const target = hexToRgb(refs.textileColor.value);
    const tolerance = Number(refs.textileTolerance.value);
    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    let changed = 0;

    for (let p = 0; p < workCanvas.width * workCanvas.height; p += 1) {
      const idx = p * 4;
      if (data[idx + 3] < 8) continue;
      changed += clearPixelByDistance(data, idx, target, tolerance, 0);
    }

    if (!changed) {
      showToast('Couleur textile non trouvee', 'error');
      return;
    }

    workCtx.putImageData(imageData, 0, 0);
    pushHistory('Couleur textile supprimee');
    detectPalette();
    render();
    showToast('Couleur textile supprimee', 'good');
  }

  function removeSemiTransparency() {
    if (!withImage()) return;
    const threshold = Number(refs.semiThreshold.value);
    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    let removed = 0;
    let hardened = 0;

    for (let p = 0; p < workCanvas.width * workCanvas.height; p += 1) {
      const idx = p * 4;
      const alpha = data[idx + 3];
      if (alpha <= 0 || alpha === 255) continue;
      if (alpha < threshold) {
        data[idx + 3] = 0;
        removed += 1;
      } else {
        data[idx + 3] = 255;
        hardened += 1;
      }
    }

    if (!removed && !hardened) {
      showToast('Aucun pixel semi-transparent');
      return;
    }

    workCtx.putImageData(imageData, 0, 0);
    pushHistory('Semi-transparence supprimee');
    detectPalette();
    render();
    showToast('Semi-transparence supprimee', 'good');
  }

  function trimWhitespace(commit = true, announce = true) {
    if (!withImage()) return;
    if (commit && announce && !needsTrimWhitespace()) {
      showToast('Aucun espace vide à retirer', 'good');
      return false;
    }
    const bounds = getContentBounds();
    if (!bounds) {
      if (announce) showToast('Aucun contenu detecte', 'error');
      return false;
    }
    if (bounds.x === 0 && bounds.y === 0 && bounds.w === workCanvas.width && bounds.h === workCanvas.height) {
      if (announce) showToast('Aucun espace vide detecte');
      return false;
    }
    cropToRect(bounds, commit ? 'Espaces vides retires' : '');
    if (commit) {
      pushHistory('Espaces vides retires');
      detectPalette();
      render();
      if (announce) showToast('Espaces vides retires', 'good');
    }
    return true;
  }

  function startCrop() {
    if (!withImage()) return;
    const bounds = getContentBounds() || { x: 0, y: 0, w: workCanvas.width, h: workCanvas.height };
    state.crop = { rect: expandRect(bounds, 8, workCanvas.width, workCanvas.height) };
    render();
  }

  function cancelCrop() {
    state.crop = null;
    state.drag = null;
    state.qualityCache = null;
    render();
  }

  function autoCropBox() {
    if (!withImage()) return;
    const bounds = getContentBounds();
    if (!bounds) {
      showToast('Aucun contenu detecte', 'error');
      return;
    }
    state.crop = { rect: expandRect(bounds, 4, workCanvas.width, workCanvas.height) };
    render();
  }

  function applyCrop() {
    if (!withImage() || !state.crop) return;
    cropToRect(state.crop.rect, 'Crop');
    state.crop = null;
    pushHistory('Crop');
    detectPalette();
    render();
    showToast('Logo recadre', 'good');
  }

  function cropToRect(rect) {
    ensurePrintSize();
    const previousWidth = workCanvas.width;
    const previousHeight = workCanvas.height;
    const previousPrintWidth = state.printWidthCm;
    const previousPrintHeight = state.printHeightCm;
    const x = Math.round(clamp(rect.x, 0, workCanvas.width - 1));
    const y = Math.round(clamp(rect.y, 0, workCanvas.height - 1));
    const w = Math.round(clamp(rect.w, 1, workCanvas.width - x));
    const h = Math.round(clamp(rect.h, 1, workCanvas.height - y));
    const next = document.createElement('canvas');
    next.width = w;
    next.height = h;
    next.getContext('2d').drawImage(workCanvas, x, y, w, h, 0, 0, w, h);
    workCanvas.width = w;
    workCanvas.height = h;
    workCtx.clearRect(0, 0, w, h);
    workCtx.drawImage(next, 0, 0);
    state.printWidthCm = Math.max(0.1, previousPrintWidth * (w / previousWidth));
    state.printHeightCm = Math.max(0.1, previousPrintHeight * (h / previousHeight));
    state.qualityCache = null;
  }

  async function resizeLogo() {
    if (!withImage()) return;
    const previousWidthCm = getPrintWidthCm();
    const previousHeightCm = getPrintHeightCm();
    const widthCm = toPositiveNumber(refs.resizeWidth.value, previousWidthCm);
    const heightCm = toPositiveNumber(refs.resizeHeight.value, previousHeightCm);
    if (Math.abs(widthCm - previousWidthCm) < 0.05 && Math.abs(heightCm - previousHeightCm) < 0.05) {
      showToast('Dimensions inchangees');
      return;
    }

    setPrintSize(widthCm, heightCm);
    pushHistory('Dimensions modifiees', { preserveVectorExport: true });
    updateResizeInputs();
    updateInterface();
    render();
    showToast('Taille d\'impression mise a jour', 'good');
    void refreshMaestroValidation();
  }

  async function upscaleLogo() {
    if (!withImage()) return;
    if (state.vectorSvg) {
      showToast('Amelioration desactivee sur une version vectorielle', 'error');
      return;
    }
    const factor = toPositiveInt(refs.upscaleFactor.value, 2);
    const width = workCanvas.width * factor;
    const height = workCanvas.height * factor;
    if (!canCreateOutput(width, height)) return;

    setBusy('Upscale');
    await nextFrame();
    try {
      let upscaled = null;
      if (refs.upscaleEngine.value === 'ai') {
        try {
          upscaled = await upscaleWithUpscalerJs(width, height);
          refs.upscaleStatus.textContent = 'IA prete';
        } catch (error) {
          console.warn('UpscalerJS unavailable, using local upscale', error);
          refs.upscaleStatus.textContent = 'Local';
          showToast('IA indisponible, moteur local utilise');
        }
      }
      if (!upscaled) {
        upscaled = resampleCanvas(workCanvas, width, height, { sharpen: true, amount: 0.52 });
      }
      commitCanvasResult(upscaled, `Upscale x${factor}`);
      showToast(`Image amelioree x${factor}`, 'good');
    } catch (error) {
      console.error(error);
      showToast('Upscale impossible', 'error');
    } finally {
      setBusy('Pret');
    }
  }

  async function upscaleWithUpscalerJs(targetWidth, targetHeight) {
    await ensureUpscalerJs();
    if (!state.upscalerInstance) {
      state.upscalerInstance = new window.Upscaler({
        model: window.DefaultUpscalerJSModel,
      });
    }
    const resultSrc = await state.upscalerInstance.upscale(workCanvas.toDataURL('image/png'));
    const image = await loadImage(resultSrc);
    const result = document.createElement('canvas');
    result.width = image.naturalWidth;
    result.height = image.naturalHeight;
    const ctx = result.getContext('2d');
    ctx.drawImage(image, 0, 0);
    if (result.width === targetWidth && result.height === targetHeight) {
      return result;
    }
    return resampleCanvas(result, targetWidth, targetHeight, { sharpen: true, amount: 0.32 });
  }

  async function ensureUpscalerJs() {
    if (window.Upscaler && window.DefaultUpscalerJSModel) {
      state.upscalerReady = true;
      return;
    }
    await loadExternalScript(root.dataset.upscalerTfUrl || 'https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@latest/dist/tf.min.js');
    await loadExternalScript(root.dataset.upscalerModelUrl || 'https://cdn.jsdelivr.net/npm/@upscalerjs/default-model@latest/dist/umd/index.min.js');
    await loadExternalScript(root.dataset.upscalerUrl || 'https://cdn.jsdelivr.net/npm/upscaler@latest/dist/browser/umd/upscaler.min.js');
    if (!window.Upscaler || !window.DefaultUpscalerJSModel) {
      throw new Error('UpscalerJS non charge');
    }
    state.upscalerReady = true;
  }

  function loadExternalScript(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing?.dataset.loaded === 'true') {
        resolve();
        return;
      }
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error(`Chargement impossible: ${src}`)), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = () => reject(new Error(`Chargement impossible: ${src}`));
      document.head.appendChild(script);
    });
  }

  function resampleCanvas(source, width, height, options = {}) {
    const resized = document.createElement('canvas');
    resized.width = width;
    resized.height = height;
    const ctx = resized.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, 0, 0, width, height);
    if (options.sharpen) {
      sharpenCanvas(resized, options.amount || 0.42);
    }
    return resized;
  }

  function sharpenCanvas(canvas, amount) {
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const source = imageData.data;
    const copy = new Uint8ClampedArray(source);
    const w = canvas.width;
    const h = canvas.height;

    for (let y = 1; y < h - 1; y += 1) {
      for (let x = 1; x < w - 1; x += 1) {
        const idx = (y * w + x) * 4;
        if (copy[idx + 3] < 8) continue;
        for (let c = 0; c < 3; c += 1) {
          const blur = (
            copy[((y - 1) * w + x) * 4 + c] +
            copy[((y + 1) * w + x) * 4 + c] +
            copy[(y * w + x - 1) * 4 + c] +
            copy[(y * w + x + 1) * 4 + c]
          ) / 4;
          source[idx + c] = clamp(copy[idx + c] + (copy[idx + c] - blur) * amount, 0, 255);
        }
      }
    }
    ctx.putImageData(imageData, 0, 0);
  }

  function commitCanvasResult(canvas, label, options = {}) {
    workCanvas.width = canvas.width;
    workCanvas.height = canvas.height;
    workCtx.clearRect(0, 0, canvas.width, canvas.height);
    workCtx.drawImage(canvas, 0, 0);
    state.crop = null;
    pushHistory(label, options);
    detectPalette();
    fitToView(false);
    render();
  }

  function applyImageAdjustments() {
    if (!withImage()) return;
    const brightness = Number(refs.adjustBrightness.value) || 0;
    const contrast = Number(refs.adjustContrast.value) || 0;
    const saturation = Number(refs.adjustSaturation.value) || 0;

    if (brightness === 0 && contrast === 0 && saturation === 0) {
      showToast('Aucun ajustement a appliquer');
      return;
    }

    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    const brightnessOffset = brightness * 2.55;
    const contrastValue = contrast * 2.55;
    const contrastFactor = (259 * (contrastValue + 255)) / (255 * (259 - contrastValue));
    const saturationFactor = 1 + saturation / 100;

    for (let idx = 0; idx < data.length; idx += 4) {
      if (data[idx + 3] < 8) continue;
      let r = contrastFactor * (data[idx] - 128) + 128 + brightnessOffset;
      let g = contrastFactor * (data[idx + 1] - 128) + 128 + brightnessOffset;
      let b = contrastFactor * (data[idx + 2] - 128) + 128 + brightnessOffset;
      const luminance = r * 0.2126 + g * 0.7152 + b * 0.0722;
      data[idx] = clamp(luminance + (r - luminance) * saturationFactor, 0, 255);
      data[idx + 1] = clamp(luminance + (g - luminance) * saturationFactor, 0, 255);
      data[idx + 2] = clamp(luminance + (b - luminance) * saturationFactor, 0, 255);
    }

    workCtx.putImageData(imageData, 0, 0);
    pushHistory('Image ajustee');
    resetAdjustmentControls(false);
    detectPalette();
    render();
    showToast('Ajustements appliques', 'good');
  }

  function resetAdjustmentControls(shouldToast = true) {
    refs.adjustBrightness.value = 0;
    refs.adjustContrast.value = 0;
    refs.adjustSaturation.value = 0;
    updateRangeLabels();
    if (shouldToast) showToast('Ajustements remis a zero');
  }

  function rotateLogo(degrees) {
    if (!withImage()) return;
    const angle = ((degrees % 360) + 360) % 360;
    if (angle === 0) return;

    const radians = angle * Math.PI / 180;
    const rightAngle = angle === 90 || angle === 270;
    const next = document.createElement('canvas');
    next.width = rightAngle ? workCanvas.height : workCanvas.width;
    next.height = rightAngle ? workCanvas.width : workCanvas.height;
    const ctx = next.getContext('2d');
    ctx.clearRect(0, 0, next.width, next.height);
    ctx.translate(next.width / 2, next.height / 2);
    ctx.rotate(radians);
    ctx.drawImage(workCanvas, -workCanvas.width / 2, -workCanvas.height / 2);

    const previousPrintWidth = getPrintWidthCm();
    const previousPrintHeight = getPrintHeightCm();
    workCanvas.width = next.width;
    workCanvas.height = next.height;
    workCtx.clearRect(0, 0, next.width, next.height);
    workCtx.drawImage(next, 0, 0);
    if (rightAngle) {
      state.printWidthCm = previousPrintHeight;
      state.printHeightCm = previousPrintWidth;
    } else {
      state.printWidthCm = previousPrintWidth;
      state.printHeightCm = previousPrintHeight;
    }

    pushHistory(`Rotation ${degrees} degres`);
    detectPalette();
    fitToView(false);
    render();
    showToast('Rotation appliquee', 'good');
  }

  function canCreateOutput(width, height) {
    if (width > MAX_OUTPUT_EDGE || height > MAX_OUTPUT_EDGE || width * height > 90000000) {
      showToast('Image trop grande pour le navigateur', 'error');
      return false;
    }
    return true;
  }

  function detectPalette() {
    state.palette = [];
    state.detectedColorCount = 0;
    if (!hasImage()) {
      syncVectorColorsDefault();
      return;
    }

    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    const buckets = new Map();
    let visible = 0;
    const mergeTolerance = Number(refs.colorTolerance?.value || 34);
    const step = Math.max(1, Math.floor(Math.sqrt((workCanvas.width * workCanvas.height) / 90000)));

    for (let y = 0; y < imageData.height; y += step) {
      for (let x = 0; x < imageData.width; x += step) {
        const idx = (y * imageData.width + x) * 4;
        if (data[idx + 3] < 20) continue;
        visible += 1;
        const r = Math.round(data[idx] / 16) * 16;
        const g = Math.round(data[idx + 1] / 16) * 16;
        const b = Math.round(data[idx + 2] / 16) * 16;
        const key = `${clamp(r, 0, 255)},${clamp(g, 0, 255)},${clamp(b, 0, 255)}`;
        const current = buckets.get(key) || { count: 0, r: 0, g: 0, b: 0 };
        current.count += 1;
        current.r += data[idx];
        current.g += data[idx + 1];
        current.b += data[idx + 2];
        buckets.set(key, current);
      }
    }

    const sortedBuckets = Array.from(buckets.values())
      .map((item) => ({
        count: item.count,
        color: [
          Math.round(item.r / item.count),
          Math.round(item.g / item.count),
          Math.round(item.b / item.count),
        ],
      }))
      .sort((a, b) => b.count - a.count);

    const groups = [];
    for (const bucket of sortedBuckets) {
      const matchingGroup = groups.find((group) => colorDistance(group.color, bucket.color) <= mergeTolerance);
      if (matchingGroup) {
        const nextCount = matchingGroup.count + bucket.count;
        matchingGroup.color = [
          Math.round(((matchingGroup.color[0] * matchingGroup.count) + (bucket.color[0] * bucket.count)) / nextCount),
          Math.round(((matchingGroup.color[1] * matchingGroup.count) + (bucket.color[1] * bucket.count)) / nextCount),
          Math.round(((matchingGroup.color[2] * matchingGroup.count) + (bucket.color[2] * bucket.count)) / nextCount),
        ];
        matchingGroup.count = nextCount;
        matchingGroup.shadeCount += 1;
        matchingGroup.sources.push(bucket.color);
      } else {
        groups.push({
          count: bucket.count,
          color: bucket.color,
          shadeCount: 1,
          sources: [bucket.color],
        });
      }
    }

    state.detectedColorCount = groups.length;
    state.palette = groups
      .sort((a, b) => b.count - a.count)
      .slice(0, 10)
      .map((item) => ({
        hex: rgbToHex(item.color),
        count: item.count,
        percent: visible ? Math.round((item.count / visible) * 100) : 0,
        shadeCount: item.shadeCount,
        sources: item.sources.map((color) => rgbToHex(color)),
      }));
    syncVectorColorsDefault();
  }

  function syncVectorColorsDefault(force = false) {
    if (!refs.vectorColors) return;
    const next = state.detectedColorCount
      ? clamp(state.detectedColorCount, 2, 50)
      : 8;
    const current = Number(refs.vectorColors.value);
    const stillAuto = state.vectorColorsAuto == null || current === state.vectorColorsAuto;
    if (force || !Number.isFinite(current) || stillAuto) {
      refs.vectorColors.value = String(next);
    }
    state.vectorColorsAuto = next;
  }

  function getDesiredVectorColorCount() {
    const raw = Number(refs.vectorColors && refs.vectorColors.value);
    if (Number.isFinite(raw) && raw > 0) return clamp(Math.round(raw), 2, 50);
    if (state.detectedColorCount > 0) return clamp(state.detectedColorCount, 2, 50);
    return 8;
  }

  function renderColorList() {
    if (!hasImage()) {
      refs.colorList.innerHTML = '<div class="le-vector-preview"><span>Aucune couleur</span></div>';
      return;
    }

    if (!state.palette.length) {
      refs.colorList.innerHTML = '<div class="le-vector-preview"><span>Aucune couleur</span></div>';
      return;
    }

    refs.colorList.innerHTML = state.palette.map((color, index) => {
      const shadeLabel = color.shadeCount > 1 ? ` · ${color.shadeCount} teintes proches` : '';
      return `
        <div class="le-color-row" data-source="${color.hex}" data-sources="${color.sources.join(',')}">
          <input class="le-color-select" type="checkbox" data-color-select aria-label="Selectionner ${color.hex}">
          <span class="le-color-swatch" style="background:${color.hex}"></span>
          <span class="le-color-info">
            <strong>${color.hex.toUpperCase()}</strong>
            <span>${color.percent}% du logo${shadeLabel}</span>
          </span>
          <input type="color" value="${color.hex}" data-color-target="${index}" aria-label="Nouvelle couleur ${color.hex}">
        </div>
      `;
    }).join('');
    updateColorBulkVisibility();
  }

  function updateColorBulkVisibility() {
    if (!refs.colorBulk) return;
    const selectedCount = $$('.le-color-row [data-color-select]:checked').length;
    refs.colorBulk.hidden = selectedCount < 2;
  }

  function applyBulkColorToSelection() {
    const selectedRows = $$('.le-color-row').filter((row) => row.querySelector('[data-color-select]')?.checked);
    if (selectedRows.length < 2) {
      showToast('Selectionnez au moins deux couleurs');
      return;
    }

    const targetHex = refs.bulkColor?.value || '#000000';
    selectedRows.forEach((row) => {
      const colorInput = row.querySelector('input[type="color"]');
      if (colorInput) colorInput.value = targetHex;
      row.classList.add('is-bulk-ready');
    });
    showToast(`${selectedRows.length} couleur(s) preparee(s)`);
  }

  function clearColorSelection() {
    $$('.le-color-row').forEach((row) => {
      const checkbox = row.querySelector('[data-color-select]');
      if (checkbox) checkbox.checked = false;
      row.classList.remove('is-selected', 'is-bulk-ready');
    });
    updateColorBulkVisibility();
  }

  function applyColorChanges() {
    if (!withImage()) return;
    const mappings = $$('.le-color-row').map((row) => ({
      source: hexToRgb(row.dataset.source),
      sources: (row.dataset.sources || row.dataset.source).split(',').map(hexToRgb),
      sourceHex: row.dataset.source.toLowerCase(),
      target: hexToRgb(row.querySelector('input[type="color"]').value),
      targetHex: row.querySelector('input[type="color"]').value.toLowerCase(),
    })).filter((item) => item.sourceHex !== item.targetHex);

    if (!mappings.length) {
      showToast('Aucune couleur modifiee');
      return;
    }

    const tolerance = Number(refs.colorTolerance.value);
    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    let changed = 0;

    for (let p = 0; p < workCanvas.width * workCanvas.height; p += 1) {
      const idx = p * 4;
      if (data[idx + 3] < 8) continue;
      let best = null;
      let bestDistance = Infinity;
      for (const mapping of mappings) {
        let distance = Infinity;
        for (const source of mapping.sources) {
          distance = Math.min(distance, colorDistanceAt(data, idx, source));
          if (distance <= 1) break;
        }
        if (distance < bestDistance) {
          best = mapping;
          bestDistance = distance;
        }
      }
      if (best && bestDistance <= tolerance) {
        data[idx] = best.target[0];
        data[idx + 1] = best.target[1];
        data[idx + 2] = best.target[2];
        changed += 1;
      }
    }

    if (!changed) {
      showToast('Aucun pixel remplace', 'error');
      return;
    }

    workCtx.putImageData(imageData, 0, 0);
    pushHistory('Couleurs modifiees');
    detectPalette();
    render();
    showToast('Couleurs appliquees', 'good');
  }

  function shouldPreferRemoveBackgroundBeforeVectorize() {
    if (!hasImage()) return false;
    if (!state.qualityCache) state.qualityCache = analyzeLogoQuality();
    const quality = state.qualityCache;
    return Boolean(quality && quality.hasContent && !quality.transparentBackground);
  }

  async function confirmVectorizeDespiteBackground() {
    if (!shouldPreferRemoveBackgroundBeforeVectorize()) return true;
    const message = [
      'Un fond opaque a été détecté.',
      'Il est préférable de retirer le fond avant de vectoriser, pour éviter de vectoriser le fond avec le logo.',
      '',
      'Continuer la vectorisation quand même ?',
    ].join('\n');
    return window.confirm(message);
  }

  async function vectorize() {
    if (!withImage()) return;
    if (isVectorFile() && !(hasMaestroResult() && maestroAlerts().resolution)) {
      showToast('Ce fichier est déjà vectoriel', 'good');
      return;
    }
    if (hasMaestroResult() && !maestroAlerts().resolution) {
      showToast('La résolution est suffisante, pas besoin de vectoriser', 'good');
      return;
    }
    if (!(await confirmVectorizeDespiteBackground())) {
      const removeBgDrawer = refs.drawers?.removeBg;
      if (removeBgDrawer) {
        removeBgDrawer.open = true;
        Object.values(refs.drawers || {}).forEach((drawer) => {
          if (drawer && drawer !== removeBgDrawer) drawer.open = false;
        });
        removeBgDrawer.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      showToast('Retirez le fond avant de vectoriser', 'error');
      return;
    }
    clearVector();
    hideVectorStage();
    setBusy('Vectorisation IA');
    setStageLoading(true, 'Vectorisation en cours', 'Traitement IA');
    let committed = false;
    try {
      const maxColors = getDesiredVectorColorCount();
      const source = await canvasToPngBlob();

      // Production SVG for crisp stage preview. Credits are charged only on PDF download.
      setStageLoading(true, 'Récupération du fichier', 'SVG production');
      const svgResult = await amptVectorize(source, maxColors, 'svg', 'production');
      let svgText = '';
      if (svgResult && svgResult.kind === 'svg' && svgResult.text) {
        svgText = String(svgResult.text);
      } else {
        const pngResult = await amptVectorize(source, maxColors, 'png', 'production');
        if (pngResult && pngResult.kind === 'svg' && pngResult.text) {
          svgText = String(pngResult.text);
        } else if (pngResult && pngResult.blob) {
          await loadBlobIntoWorkCanvas(pngResult.blob, 'Vectorisation IA');
        }
      }

      state.vectorMeta = { source: 'IA', colors: maxColors };
      // Raster that produced the SVG — used if the cached API PDF is missing.
      state.vectorSourceBlob = source;

      if (svgText) {
        state.vectorSvg = svgText;
        state.vectorExportReady = true;
        if (refs.vectorStatus) refs.vectorStatus.textContent = maxColors + ' couleurs';
        setVectorSidebarPreview(new Blob([svgText], { type: 'image/svg+xml' }));
        state.qualityCache = null;
        render();
        committed = true;
        showToast('Logo vectorise', 'good');

        try {
          await rasterizeSvgIntoWorkCanvas(svgText, 'Vectorisation IA', {
            preserveVectorExport: true,
            usePrintDpi: true,
            maxEdge: MAX_OUTPUT_EDGE,
          });
          // pushHistory used to clear vector state — keep production SVG for export.
          state.vectorSvg = svgText;
          state.vectorExportReady = true;
          state.vectorSourceBlob = source;
          render();
        } catch (previewError) {
          console.warn('Rasterisation aperçu vectoriel impossible', previewError);
        }

        // Never block or roll back a successful SVG on the production PDF call.
        prefetchAmptProductionPdf(source, maxColors);
      } else {
        if (refs.vectorStatus) refs.vectorStatus.textContent = maxColors + ' couleurs';
        setVectorSidebarPreview(workCanvas.toDataURL('image/png'));
        state.qualityCache = null;
        render();
        showToast('Logo vectorise', 'good');
      }
    } catch (error) {
      console.error(error);
      if (!committed) {
        clearVector();
        showToast(error.message || 'Vectorisation impossible', 'error');
      } else {
        showToast(error.message || 'Aperçu vectoriel incomplet', 'error');
      }
    } finally {
      setStageLoading(false);
      setBusy('Pret');
    }
  }

  function vectorizeLocally() {
    const maxEdge = Number(refs.vectorDetail.value);
    const maxColors = getDesiredVectorColorCount();
    const scaled = makeScaledCanvas(workCanvas, maxEdge);
    const imageData = scaled.ctx.getImageData(0, 0, scaled.canvas.width, scaled.canvas.height);
    if (window.ImageTracer?.imagedataToSVG) {
      return vectorizeWithImageTracer(imageData, maxColors, state.fileName, workCanvas.width, workCanvas.height);
    }
    const fallback = buildVectorSvg(imageData, Math.min(maxColors, 16), state.fileName, workCanvas.width, workCanvas.height);
    fallback.meta.source = 'Local';
    return fallback;
  }

  function applyVectorResult(result) {
    const svgText = String(result.svg || '');
    state.vectorSvg = svgText;
    state.vectorMeta = result.meta;
    state.vectorPdfBlob = result.pdfBlob || null;
    state.vectorExportReady = true;
    if (state.vectorObjectUrl) URL.revokeObjectURL(state.vectorObjectUrl);
    state.vectorObjectUrl = '';
    if (refs.vectorStatus) refs.vectorStatus.textContent = formatVectorColorLabel(result.meta.colors);
    rasterizeSvgIntoWorkCanvas(svgText, 'Vectorisation', {
      preserveVectorExport: true,
      usePrintDpi: true,
      maxEdge: MAX_OUTPUT_EDGE,
    })
      .then(() => {
        state.vectorSvg = svgText;
        state.vectorExportReady = true;
        setVectorSidebarPreview(new Blob([svgText], { type: 'image/svg+xml' }));
        fitToView(false);
        render();
      })
      .catch((error) => {
        console.error(error);
        showToast(error.message || 'Aperçu vectoriel impossible', 'error');
      });
  }

  function readSvgGeometry(svgText) {
    const viewBox = getSvgAttribute(svgText.match(/<svg\b([^>]*)>/i)?.[1] || '', 'viewBox')
      .split(/[\s,]+/)
      .map(Number)
      .filter(Number.isFinite);
    if (viewBox.length === 4 && viewBox[2] > 0 && viewBox[3] > 0) {
      return { x: viewBox[0], y: viewBox[1], width: viewBox[2], height: viewBox[3] };
    }
    const svgAttrs = svgText.match(/<svg\b([^>]*)>/i)?.[1] || '';
    const width = parseFloat(getSvgAttribute(svgAttrs, 'width')) || workCanvas.width;
    const height = parseFloat(getSvgAttribute(svgAttrs, 'height')) || workCanvas.height;
    return { x: 0, y: 0, width, height };
  }

  function extractFilledSvgPaths(svgText) {
    const paths = [];
    const cleaned = sanitizeVectorSvg(svgText);
    const pathPattern = /<path\b([^>]*)>/gi;
    let match;
    while ((match = pathPattern.exec(cleaned))) {
      const attrs = match[1];
      const d = getSvgAttribute(attrs, 'd');
      const fill = getSvgAttribute(attrs, 'fill') || getStyleValue(attrs, 'fill') || '#000000';
      if (!d || fill.toLowerCase() === 'none') continue;
      paths.push({
        d,
        fill,
        opacity: parseSvgOpacity(attrs),
      });
    }

    // Convert simple polygons to path data when Ampt returns few <path> nodes.
    const polygonPattern = /<polygon\b([^>]*)>/gi;
    while ((match = polygonPattern.exec(cleaned))) {
      const attrs = match[1];
      const points = getSvgAttribute(attrs, 'points');
      const fill = getSvgAttribute(attrs, 'fill') || getStyleValue(attrs, 'fill') || '#000000';
      if (!points || fill.toLowerCase() === 'none') continue;
      const nums = points.trim().split(/[\s,]+/).map(Number).filter(Number.isFinite);
      if (nums.length < 6) continue;
      let d = `M${nums[0]} ${nums[1]}`;
      for (let i = 2; i < nums.length; i += 2) d += `L${nums[i]} ${nums[i + 1]}`;
      d += 'Z';
      paths.push({ d, fill, opacity: parseSvgOpacity(attrs) });
    }
    return paths;
  }

  function getSvgAttribute(attrs, name) {
    const pattern = new RegExp(`${name}\\s*=\\s*(?:"([^"]*)"|'([^']*)')`, 'i');
    const match = String(attrs || '').match(pattern);
    return match ? (match[1] || match[2] || '').trim() : '';
  }

  function getStyleValue(attrs, name) {
    const style = getSvgAttribute(attrs, 'style');
    const pattern = new RegExp(`(?:^|;)\\s*${name}\\s*:\\s*([^;]+)`, 'i');
    const match = style.match(pattern);
    return match ? match[1].trim() : '';
  }

  function parseSvgOpacity(attrs) {
    const opacity = parseFloat(getSvgAttribute(attrs, 'fill-opacity') || getStyleValue(attrs, 'fill-opacity') || getSvgAttribute(attrs, 'opacity') || '1');
    return clamp(Number.isFinite(opacity) ? opacity : 1, 0, 1);
  }

  function svgFillToPdfColor(fill) {
    const clean = String(fill || '').trim().toLowerCase();
    let rgb = null;
    if (/^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(clean)) {
      rgb = hexToRgb(clean);
    } else {
      const match = clean.match(/^rgba?\(([^)]+)\)$/i);
      if (match) {
        rgb = match[1].split(',').slice(0, 3).map((value) => parseFloat(value));
      } else {
        const named = {
          black: [0, 0, 0],
          white: [255, 255, 255],
          red: [255, 0, 0],
          green: [0, 128, 0],
          blue: [0, 0, 255],
          gray: [128, 128, 128],
          grey: [128, 128, 128],
        };
        if (named[clean]) rgb = named[clean];
      }
    }
    if (!rgb || rgb.length < 3 || !rgb.every(Number.isFinite)) return null;
    return window.PDFLib.rgb(
      clamp(rgb[0], 0, 255) / 255,
      clamp(rgb[1], 0, 255) / 255,
      clamp(rgb[2], 0, 255) / 255,
    );
  }

  function formatVectorColorLabel(colors) {
    const count = Number(colors);
    if (!Number.isFinite(count) || count <= 0) return 'Toutes';
    return `${count} couleur${count > 1 ? 's' : ''}`;
  }

  function makeScaledCanvas(source, maxEdge) {
    const scale = Math.min(1, maxEdge / Math.max(source.width, source.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(source.width * scale));
    canvas.height = Math.max(1, Math.round(source.height * scale));
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
    return { canvas, ctx, scale };
  }

  function vectorizeWithImageTracer(imageData, maxColors, title, originalW, originalH) {
    const detail = Math.max(imageData.width, imageData.height);
    const palette = collectVectorPalette(imageData, maxColors);
    const options = {
      ltres: detail >= 900 ? 0.45 : detail >= 600 ? 0.75 : 1.1,
      qtres: detail >= 900 ? 0.45 : detail >= 600 ? 0.75 : 1.1,
      pathomit: detail >= 900 ? 2 : detail >= 600 ? 4 : 8,
      rightangleenhance: false,
      linefilter: true,
      colorsampling: 0,
      numberofcolors: palette.length || maxColors,
      mincolorratio: 0,
      colorquantcycles: 1,
      layering: 0,
      strokewidth: 0,
      scale: 1,
      roundcoords: 2,
      viewbox: true,
      desc: false,
      blurradius: 0,
      blurdelta: 20,
      pal: palette,
    };
    const traced = window.ImageTracer.imagedataToSVG(imageData, options);
    const svg = normalizeTracedSvg(traced, title, originalW, originalH, imageData.width, imageData.height);
    const colors = new Set(Array.from(svg.matchAll(/fill="rgb\(([^"]+)\)"/g)).map((match) => match[1]));
    return {
      svg,
      meta: {
        source: 'ImageTracer',
        width: imageData.width,
        height: imageData.height,
        colors: colors.size || maxColors,
        paths: (svg.match(/<path/g) || []).length,
      },
    };
  }

  function collectVectorPalette(imageData, maxColors) {
    const buckets = new Map();
    const data = imageData.data;
    let transparent = 0;
    for (let p = 0; p < imageData.width * imageData.height; p += 1) {
      const idx = p * 4;
      const alpha = data[idx + 3];
      if (alpha < 18) {
        transparent += 1;
        continue;
      }
      const r = Math.round(data[idx] / 16) * 16;
      const g = Math.round(data[idx + 1] / 16) * 16;
      const b = Math.round(data[idx + 2] / 16) * 16;
      const key = `${clamp(r, 0, 255)},${clamp(g, 0, 255)},${clamp(b, 0, 255)}`;
      const item = buckets.get(key) || { count: 0, r: 0, g: 0, b: 0, a: 0 };
      item.count += 1;
      item.r += data[idx];
      item.g += data[idx + 1];
      item.b += data[idx + 2];
      item.a += alpha;
      buckets.set(key, item);
    }

    const palette = Array.from(buckets.values())
      .sort((a, b) => b.count - a.count)
      .slice(0, Math.max(2, maxColors))
      .map((item) => ({
        r: Math.round(item.r / item.count),
        g: Math.round(item.g / item.count),
        b: Math.round(item.b / item.count),
        a: Math.round(item.a / item.count),
      }));
    if (transparent) palette.push({ r: 255, g: 255, b: 255, a: 0 });
    return palette;
  }

  function normalizeTracedSvg(svgText, title, originalW, originalH, viewW, viewH) {
    const body = String(svgText || '')
      .replace(/^[\s\S]*?<svg\b[^>]*>/i, '')
      .replace(/<\/svg>\s*$/i, '')
      .replace(/\sdesc="[^"]*"/gi, '');
    return [
      `<svg xmlns="http://www.w3.org/2000/svg" width="${originalW}" height="${originalH}" viewBox="0 0 ${viewW} ${viewH}" role="img">`,
      `<title>${escapeXml(title.replace(/\.[^.]+$/, '') || 'Logo vectorise')}</title>`,
      '<g shape-rendering="geometricPrecision">',
      body,
      '</g>',
      '</svg>',
    ].join('');
  }

  function buildVectorSvg(imageData, maxColors, title, originalW, originalH) {
    const { data, width, height } = imageData;
    const samples = collectVectorSamples(data, width, height, 26000);
    if (!samples.length) throw new Error('Image vide');

    let centers = initialCenters(samples, maxColors);
    centers = runKMeans(samples, centers, 7);
    const simplifyEpsilon = Math.max(width, height) >= 900 ? 1.2 : Math.max(width, height) >= 600 ? 2 : 2.6;

    const indices = new Int16Array(width * height);
    indices.fill(-1);
    const used = new Array(centers.length).fill(0);

    for (let p = 0; p < width * height; p += 1) {
      const idx = p * 4;
      if (data[idx + 3] < 18) continue;
      const colorIndex = nearestCenter([data[idx], data[idx + 1], data[idx + 2]], centers);
      indices[p] = colorIndex;
      used[colorIndex] += 1;
    }

    let totalContours = 0;
    const paths = centers.map((center, index) => {
      if (!used[index]) return '';
      const contours = traceColorContours(indices, width, height, index, simplifyEpsilon);
      if (!contours.length) return '';
      const fill = rgbToHex(center.map((value) => Math.round(value)));
      const d = contours.map(contourToSvgPath).filter(Boolean).join('');
      if (!d) return '';
      totalContours += contours.length;
      return `<path fill="${fill}" fill-rule="evenodd" d="${d}"/>`;
    }).filter(Boolean);

    const svg = [
      `<svg xmlns="http://www.w3.org/2000/svg" width="${originalW}" height="${originalH}" viewBox="0 0 ${width} ${height}" role="img">`,
      `<title>${escapeXml(title.replace(/\.[^.]+$/, '') || 'Logo vectorise')}</title>`,
      '<g shape-rendering="geometricPrecision">',
      paths.join(''),
      '</g>',
      '</svg>',
    ].join('');

    return {
      svg,
      meta: {
        width,
        height,
        colors: paths.length,
        paths: totalContours,
      },
    };
  }

  function collectVectorSamples(data, width, height, maxSamples) {
    const total = width * height;
    const step = Math.max(1, Math.floor(total / maxSamples));
    const samples = [];
    for (let p = 0; p < total; p += step) {
      const idx = p * 4;
      if (data[idx + 3] < 18) continue;
      samples.push([data[idx], data[idx + 1], data[idx + 2]]);
    }
    return samples;
  }

  function initialCenters(samples, maxColors) {
    const buckets = new Map();
    samples.forEach((sample) => {
      const key = `${Math.round(sample[0] / 32) * 32},${Math.round(sample[1] / 32) * 32},${Math.round(sample[2] / 32) * 32}`;
      const item = buckets.get(key) || { count: 0, r: 0, g: 0, b: 0 };
      item.count += 1;
      item.r += sample[0];
      item.g += sample[1];
      item.b += sample[2];
      buckets.set(key, item);
    });
    const centers = Array.from(buckets.values())
      .sort((a, b) => b.count - a.count)
      .slice(0, maxColors)
      .map((item) => [item.r / item.count, item.g / item.count, item.b / item.count]);
    while (centers.length < Math.min(maxColors, samples.length)) centers.push(samples[centers.length]);
    return centers;
  }

  function runKMeans(samples, centers, iterations) {
    for (let iteration = 0; iteration < iterations; iteration += 1) {
      const totals = centers.map(() => ({ count: 0, r: 0, g: 0, b: 0 }));
      samples.forEach((sample) => {
        const index = nearestCenter(sample, centers);
        totals[index].count += 1;
        totals[index].r += sample[0];
        totals[index].g += sample[1];
        totals[index].b += sample[2];
      });
      centers = centers.map((center, index) => {
        const total = totals[index];
        if (!total.count) return center;
        return [total.r / total.count, total.g / total.count, total.b / total.count];
      });
    }
    return centers;
  }

  function nearestCenter(color, centers) {
    let best = 0;
    let bestDistance = Infinity;
    centers.forEach((center, index) => {
      const distance = colorDistance(color, center);
      if (distance < bestDistance) {
        best = index;
        bestDistance = distance;
      }
    });
    return best;
  }

  function traceColorContours(indices, width, height, colorIndex, simplifyEpsilon) {
    const edges = [];
    const starts = new Map();
    const isColor = (x, y) => x >= 0 && y >= 0 && x < width && y < height && indices[y * width + x] === colorIndex;
    const addEdge = (x1, y1, x2, y2) => {
      const edge = {
        x1,
        y1,
        x2,
        y2,
        from: `${x1},${y1}`,
        to: `${x2},${y2}`,
        used: false,
      };
      edges.push(edge);
      if (!starts.has(edge.from)) starts.set(edge.from, []);
      starts.get(edge.from).push(edge);
    };

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        if (!isColor(x, y)) continue;
        if (!isColor(x, y - 1)) addEdge(x, y, x + 1, y);
        if (!isColor(x + 1, y)) addEdge(x + 1, y, x + 1, y + 1);
        if (!isColor(x, y + 1)) addEdge(x + 1, y + 1, x, y + 1);
        if (!isColor(x - 1, y)) addEdge(x, y + 1, x, y);
      }
    }

    const contours = [];
    edges.forEach((edge) => {
      if (edge.used) return;
      const start = edge.from;
      const points = [[edge.x1, edge.y1]];
      let current = edge;
      let guard = 0;

      while (current && guard <= edges.length) {
        current.used = true;
        points.push([current.x2, current.y2]);
        if (current.to === start) break;
        const candidates = (starts.get(current.to) || []).filter((item) => !item.used);
        current = chooseContourEdge(current, candidates);
        guard += 1;
      }

      if (points.length < 4 || !pointsEqual(points[0], points[points.length - 1])) return;
      points.pop();
      const contour = smoothContourPoints(simplifyContour(points, simplifyEpsilon));
      if (contour.length >= 3 && Math.abs(polygonArea(contour)) >= 0.5) contours.push(contour);
    });

    return contours.sort((a, b) => Math.abs(polygonArea(b)) - Math.abs(polygonArea(a)));
  }

  function chooseContourEdge(current, candidates) {
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const dx = current.x2 - current.x1;
    const dy = current.y2 - current.y1;
    let best = candidates[0];
    let bestScore = -Infinity;
    candidates.forEach((edge) => {
      const ndx = edge.x2 - edge.x1;
      const ndy = edge.y2 - edge.y1;
      const cross = dx * ndy - dy * ndx;
      const dot = dx * ndx + dy * ndy;
      const score = (cross < 0 ? 4 : cross === 0 ? 3 : 2) + dot * 0.01;
      if (score > bestScore) {
        best = edge;
        bestScore = score;
      }
    });
    return best;
  }

  function simplifyContour(points, epsilon) {
    const cleaned = cleanContourPoints(points);
    if (cleaned.length <= 6) return cleaned;
    let a = 0;
    let b = farthestPointIndex(cleaned, cleaned[a]);
    a = farthestPointIndex(cleaned, cleaned[b]);
    b = farthestPointIndex(cleaned, cleaned[a]);
    const first = simplifyOpenPath(sliceClosedPoints(cleaned, a, b), epsilon);
    const second = simplifyOpenPath(sliceClosedPoints(cleaned, b, a), epsilon);
    return cleanContourPoints(first.slice(0, -1).concat(second.slice(0, -1)));
  }

  function smoothContourPoints(points) {
    if (points.length < 8 || Math.abs(polygonArea(points)) < 6) return points;
    return points.map((point, index) => {
      const prev = points[(index - 1 + points.length) % points.length];
      const next = points[(index + 1) % points.length];
      return [
        (prev[0] + point[0] * 2 + next[0]) / 4,
        (prev[1] + point[1] * 2 + next[1]) / 4,
      ];
    });
  }

  function cleanContourPoints(points) {
    const unique = [];
    points.forEach((point) => {
      if (!unique.length || !pointsEqual(unique[unique.length - 1], point)) unique.push(point);
    });
    if (unique.length > 1 && pointsEqual(unique[0], unique[unique.length - 1])) unique.pop();
    if (unique.length <= 3) return unique;

    const cleaned = [];
    for (let i = 0; i < unique.length; i += 1) {
      const prev = unique[(i - 1 + unique.length) % unique.length];
      const curr = unique[i];
      const next = unique[(i + 1) % unique.length];
      const cross = (curr[0] - prev[0]) * (next[1] - curr[1]) - (curr[1] - prev[1]) * (next[0] - curr[0]);
      if (Math.abs(cross) > 0.001) cleaned.push(curr);
    }
    return cleaned.length >= 3 ? cleaned : unique;
  }

  function simplifyOpenPath(points, epsilon) {
    if (points.length <= 2) return points;
    const start = points[0];
    const end = points[points.length - 1];
    let index = -1;
    let maxDistance = 0;
    for (let i = 1; i < points.length - 1; i += 1) {
      const distance = pointLineDistance(points[i], start, end);
      if (distance > maxDistance) {
        index = i;
        maxDistance = distance;
      }
    }
    if (maxDistance <= epsilon || index < 0) return [start, end];
    const left = simplifyOpenPath(points.slice(0, index + 1), epsilon);
    const right = simplifyOpenPath(points.slice(index), epsilon);
    return left.slice(0, -1).concat(right);
  }

  function sliceClosedPoints(points, start, end) {
    const segment = [points[start]];
    let index = start;
    while (index !== end) {
      index = (index + 1) % points.length;
      segment.push(points[index]);
    }
    return segment;
  }

  function contourToSvgPath(points) {
    const contour = cleanContourPoints(points);
    if (contour.length < 3 || Math.abs(polygonArea(contour)) < 0.5) return '';
    if (contour.length <= 5) {
      return `M${formatSvgNumber(contour[0][0])} ${formatSvgNumber(contour[0][1])}${contour
        .slice(1)
        .map((point) => `L${formatSvgNumber(point[0])} ${formatSvgNumber(point[1])}`)
        .join('')}Z`;
    }

    const mids = contour.map((point, index) => {
      const next = contour[(index + 1) % contour.length];
      return [(point[0] + next[0]) / 2, (point[1] + next[1]) / 2];
    });
    let path = `M${formatSvgNumber(mids[contour.length - 1][0])} ${formatSvgNumber(mids[contour.length - 1][1])}`;
    contour.forEach((point, index) => {
      path += `Q${formatSvgNumber(point[0])} ${formatSvgNumber(point[1])} ${formatSvgNumber(mids[index][0])} ${formatSvgNumber(mids[index][1])}`;
    });
    return `${path}Z`;
  }

  function farthestPointIndex(points, target) {
    let best = 0;
    let bestDistance = -1;
    points.forEach((point, index) => {
      const dx = point[0] - target[0];
      const dy = point[1] - target[1];
      const distance = dx * dx + dy * dy;
      if (distance > bestDistance) {
        best = index;
        bestDistance = distance;
      }
    });
    return best;
  }

  function pointLineDistance(point, start, end) {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    if (dx === 0 && dy === 0) return Math.hypot(point[0] - start[0], point[1] - start[1]);
    return Math.abs(dy * point[0] - dx * point[1] + end[0] * start[1] - end[1] * start[0]) / Math.hypot(dx, dy);
  }

  function polygonArea(points) {
    let area = 0;
    for (let i = 0; i < points.length; i += 1) {
      const next = points[(i + 1) % points.length];
      area += points[i][0] * next[1] - next[0] * points[i][1];
    }
    return area / 2;
  }

  function pointsEqual(a, b) {
    return a && b && a[0] === b[0] && a[1] === b[1];
  }

  function formatSvgNumber(value) {
    return Number(value.toFixed(2)).toString();
  }

  async function saveToLibrary() {
    if (root.dataset.hostMode === 'apply') return;
    if (!withImage() && !(state.vectorExportReady && state.vectorSvg)) {
      showToast('Importez un logo', 'error');
      return;
    }
    if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
      showToast('Connectez-vous pour sauvegarder dans Mes fichiers', 'error');
      redirectToLogin();
      return;
    }

    const uploadUrl = root.dataset.libraryUploadUrl || '/apps/easy-order/file-storage/upload';
    setBusy('Sauvegarde');
    setStageLoading(true, 'Sauvegarde dans Mes fichiers', 'Préparation du logo');
    try {
      if (state.vectorExportReady && state.vectorSvg) {
        await rasterizeSvgIntoWorkCanvas(state.vectorSvg, 'Sauvegarde', {
          preserveVectorExport: true,
          usePrintDpi: true,
          maxEdge: 4096,
        });
        state.vectorExportReady = true;
      }
      if (!hasImage()) throw new Error('Logo indisponible');

      const blob = await canvasToPngBlob();
      const widthMm = Math.round(getPrintWidthCm() * 10 * 10) / 10;
      const heightMm = Math.round(getPrintHeightCm() * 10 * 10) / 10;
      const fileName = sanitizeUploadFilename(
        `${baseName()}-${formatCmInput(getPrintWidthCm()).replace('.', ',')}x${formatCmInput(getPrintHeightCm()).replace('.', ',')}cm.png`,
        'png'
      );
      const file = new File([blob], fileName, { type: 'image/png' });

      const url = new URL(uploadUrl, window.location.origin);
      url.searchParams.set('user_id', creditConfig.customerId);
      const formData = new FormData();
      formData.append('file', file, file.name);
      if (widthMm > 0) formData.append('width_mm', String(widthMm));
      if (heightMm > 0) formData.append('height_mm', String(heightMm));

      setStageLoading(true, 'Envoi vers Mes fichiers', fileName);
      const response = await fetch(url.toString(), {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const text = await response.text();
      let json = {};
      try { json = text ? JSON.parse(text) : {}; } catch (_) { json = { message: text }; }
      if (!response.ok) {
        throw new Error(json?.message || json?.error || `Sauvegarde impossible (HTTP ${response.status})`);
      }

      showToast('Logo sauvegardé dans Mes fichiers', 'good');
    } catch (error) {
      console.error(error);
      showToast(error?.message || 'Impossible de sauvegarder le logo', 'error');
    } finally {
      setStageLoading(false);
      setBusy('Pret');
    }
  }

  async function applyToHost() {
    if (!withImage() && !(state.vectorExportReady && state.vectorSvg)) {
      showToast('Importez un logo', 'error');
      return;
    }
    const host = root.__logoEditorHost;
    if (!host || typeof host.onApply !== 'function') {
      showToast('Application indisponible', 'error');
      return;
    }

    setBusy('Application');
    setStageLoading(true, 'Application du logo', state.vectorSvg ? 'Version vectorielle IA' : 'Préparation');
    try {
      let vectorSvg = state.vectorExportReady && state.vectorSvg ? String(state.vectorSvg) : '';
      let vectorPdfDataUrl = null;

      if (vectorSvg) {
        // Refresh printable raster from the AI SVG (not the pre-vector bitmap).
        await rasterizeSvgIntoWorkCanvas(vectorSvg, 'Vectorisation IA', {
          preserveVectorExport: true,
          usePrintDpi: true,
          maxEdge: 4096,
        });
        state.vectorSvg = vectorSvg;
        state.vectorExportReady = true;

        const pdfBlob = await buildVectorPdfBlobForApply();
        if (pdfBlob?.size) {
          vectorPdfDataUrl = await readFileAsDataURL(pdfBlob);
        }
      }

      if (!hasImage()) throw new Error('Résultat vectoriel indisponible');
      const blob = await canvasToPngBlob();
      const src = await readFileAsDataURL(blob);
      const base = (state.fileName || host.fileName || 'logo').replace(/\.[^.]+$/, '');
      const result = {
        src,
        blob,
        w: workCanvas.width,
        h: workCanvas.height,
        printWidthCm: getPrintWidthCm(),
        printHeightCm: getPrintHeightCm(),
        fileName: vectorSvg ? `${base}-vectorise.png` : (state.fileName || host.fileName || 'logo.png'),
        vectorSvg: vectorSvg || null,
        vectorPdfDataUrl,
        isVector: Boolean(vectorSvg || vectorPdfDataUrl),
      };
      await host.onApply(result);
      closeEditor({ skipHostClose: true });
      if (typeof host.onClose === 'function') host.onClose({ applied: true });
    } catch (error) {
      console.error(error);
      showToast(error?.message || 'Application impossible', 'error');
    } finally {
      setStageLoading(false);
      setBusy('Pret');
    }
  }

  async function downloadPdf() {
    if (!withImage()) return;
    if (state.vectorExportReady || state.vectorSvg) {
      await downloadVectorPdf();
      return;
    }
    if (!window.PDFLib) {
      showToast('Export PDF indisponible', 'error');
      return;
    }
    if (!(await confirmDownloadCredit('PDF'))) return;
    if (!(await consumeDownloadCredit())) return;
    setBusy('Export PDF');
    try {
      const pdf = await window.PDFLib.PDFDocument.create();
      const blob = await canvasToBlob(workCanvas, 'image/png');
      const bytes = await blob.arrayBuffer();
      const image = await pdf.embedPng(bytes);
      const { widthPt: pageW, heightPt: pageH } = getPrintPagePoints();
      const page = pdf.addPage([pageW, pageH]);
      page.drawImage(image, { x: 0, y: 0, width: pageW, height: pageH });
      const pdfBytes = await pdf.save();
      const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
      downloadBlob(pdfBlob, `${baseName()}-retouche.pdf`);
      syncCreditsAfterDownload();
    } catch (error) {
      console.error(error);
      showToast('Export PDF impossible', 'error');
    } finally {
      setBusy('Pret');
    }
  }

  async function resolveAmptVectorPdf() {
    const maxColors = Number(state.vectorMeta?.colors) || getDesiredVectorColorCount();

    if (await isPdfBlob(state.vectorPdfBlob)) return state.vectorPdfBlob;

    if (pendingVectorPdf) {
      try {
        const prefetched = await pendingVectorPdf;
        if (await isPdfBlob(prefetched)) return prefetched;
        if (await isPdfBlob(state.vectorPdfBlob)) return state.vectorPdfBlob;
      } catch (error) {
        console.warn('PDF Ampt en cours impossible', error);
      }
    }

    if (state.vectorSourceBlob) {
      try {
        const fromSource = await fetchAmptProductionPdf(state.vectorSourceBlob, maxColors);
        if (fromSource) {
          state.vectorPdfBlob = fromSource;
          return fromSource;
        }
      } catch (error) {
        console.warn('PDF Ampt depuis source vectorisée impossible', error);
      }
    }

    const svgBlob = vectorizedSvgBlob();
    if (svgBlob) {
      try {
        const fromSvg = await fetchAmptProductionPdf(svgBlob, maxColors);
        if (fromSvg) {
          state.vectorPdfBlob = fromSvg;
          return fromSvg;
        }
      } catch (error) {
        console.warn('PDF Ampt depuis SVG vectorisé impossible', error);
      }
    }

    if (state.vectorSvg && extractFilledSvgPaths(state.vectorSvg).length) {
      try {
        const localPdf = await createPdfFromVectorSvg(state.vectorSvg);
        if (await isPdfBlob(localPdf)) return localPdf;
      } catch (error) {
        console.warn('PDF vectoriel local impossible', error);
      }
    }

    return null;
  }

  async function downloadVectorPdf() {
    if (!(await confirmDownloadCredit('PDF'))) return;
    setBusy('PDF vectoriel');
    setStageLoading(true, 'Preparation du PDF', 'Export vectoriel');
    let pdfBlob = null;
    try {
      pdfBlob = await resolveAmptVectorPdf();
      if (!(await isPdfBlob(pdfBlob))) throw new Error('PDF vectoriel indisponible');
    } catch (error) {
      console.error(error);
      showToast(error.message || 'PDF vectoriel indisponible', 'error');
      return;
    } finally {
      setStageLoading(false);
      setBusy('Pret');
    }

    // Le credit n'est debite qu'une fois le fichier vectoriel reellement produit.
    if (!(await consumeDownloadCredit())) return;
    downloadBlob(pdfBlob, `${baseName()}-vectorise.pdf`);
    showToast('PDF vectoriel téléchargé', 'good');
    syncCreditsAfterDownload();
  }

  function sanitizeVectorSvg(svgText) {
    return String(svgText || '')
      // Embedded rasters become a grey "X" frame in PDF viewers when broken/unlinked.
      .replace(/<image\b[^>]*>[\s\S]*?<\/image>/gi, '')
      .replace(/<image\b[^>]*\/?>/gi, '')
      .replace(/<foreignObject\b[^>]*>[\s\S]*?<\/foreignObject>/gi, '')
      .replace(/<use\b[^>]*\/?>/gi, '')
      .replace(/\s(?:xlink:)?href=["']data:image\/[^"']*["']/gi, '');
  }

  async function createPdfFromVectorSvg(svgInput) {
    if (!window.PDFLib) throw new Error('Export PDF indisponible');
    const svgText = sanitizeVectorSvg(svgInput || state.vectorSvg);
    const geometry = readSvgGeometry(svgText);
    const paths = extractFilledSvgPaths(svgText);
    if (!paths.length) throw new Error('PDF vectoriel local impossible');

    const pdf = await window.PDFLib.PDFDocument.create();
    const { widthPt: pageW, heightPt: pageH } = getPrintPagePoints();
    const page = pdf.addPage([pageW, pageH]);
    const scale = Math.min(pageW / geometry.width, pageH / geometry.height);
    // drawSvgPath garde le repere SVG (y vers le bas) : le point donne est le coin
    // haut-gauche du viewBox, pas le coin bas-gauche de la page.
    const originX = (pageW - geometry.width * scale) / 2 - geometry.x * scale;
    const originY = pageH - (pageH - geometry.height * scale) / 2 + geometry.y * scale;
    let drawn = 0;

    paths.forEach((path) => {
      const color = svgFillToPdfColor(path.fill);
      if (!color) return;
      try {
        // Le trace est passe tel quel : pdf-lib gere C, S, A, H, V et le relatif,
        // que la vectorisation de production utilise.
        page.drawSvgPath(path.d, {
          x: originX,
          y: originY,
          scale,
          color,
          opacity: path.opacity,
        });
        drawn += 1;
      } catch (error) {
        console.warn('Trace vectoriel ignore', error);
      }
    });

    if (!drawn) throw new Error('PDF vectoriel local impossible');
    const pdfBytes = await pdf.save();
    return new Blob([pdfBytes], { type: 'application/pdf' });
  }

  function resetEditor() {
    workCanvas.width = 0;
    workCanvas.height = 0;
    state.fileName = '';
    state.fileKind = '';
    state.uploadFile = null;
    state.sourceIsVector = false;
    resetMaestroState();
    closeMaestroZones();
    state.history = [];
    state.redo = [];
    state.palette = [];
    state.detectedColorCount = 0;
    state.vectorColorsAuto = null;
    state.printWidthCm = 0;
    state.printHeightCm = 0;
    state.crop = null;
    state.drag = null;
    state.pan = null;
    clearVector();
    syncVectorColorsDefault(true);
    render();
    showToast('Editeur reinitialise');
  }

  function closeEditor(options = {}) {
    const host = root.__logoEditorHost;
    const launcher = root.__logoEditorLauncher;
    if (launcher || host) {
      root.remove();
      if (!document.querySelector('[data-logo-editor]')) {
        document.body.classList.remove('le-editor-open');
      }
      if (launcher && typeof launcher.setAttribute === 'function') {
        launcher.setAttribute('aria-expanded', 'false');
      }
      if (launcher && typeof launcher.focus === 'function') {
        launcher.focus();
      }
      if (!options.skipHostClose && typeof host?.onClose === 'function') {
        try { host.onClose({ applied: false }); } catch (error) { console.warn(error); }
      }
      return;
    }

    document.body.classList.remove('le-editor-open');
    window.location.href = root.dataset.closeUrl || '/pages/editeur-en-ligne-de-logo';
  }

  function showVectorStagePreview() {
    if (!refs.vectorStage || !state.vectorSvg) return;
    const prepared = prepareSvgForStage(state.vectorSvg);
    if (refs.vectorStage.dataset.svgHash !== prepared.hash) {
      refs.vectorStage.innerHTML = prepared.markup;
      refs.vectorStage.dataset.svgHash = prepared.hash;
    }
    refs.vectorStage.hidden = false;
    refs.vectorStage.setAttribute('aria-hidden', 'false');
    refs.vectorStage.classList.add('is-visible');
  }

  function prepareSvgForStage(svgText) {
    const cleaned = sanitizeVectorSvg(svgText);
    const geometry = readSvgGeometry(cleaned);
    const markup = cleaned.replace(/<svg\b([^>]*)>/i, (match, attrs) => {
      let next = String(attrs || '')
        .replace(/\swidth=(['"]).*?\1/i, '')
        .replace(/\sheight=(['"]).*?\1/i, '');
      if (!/\sviewBox=/i.test(next) && geometry.width && geometry.height) {
        next += ` viewBox="${geometry.x || 0} ${geometry.y || 0} ${geometry.width} ${geometry.height}"`;
      }
      if (!/\spreserveAspectRatio=/i.test(next)) {
        next += ' preserveAspectRatio="xMidYMid meet"';
      }
      return `<svg${next} width="100%" height="100%">`;
    });
    return { markup, hash: String(markup.length) + ':' + markup.slice(0, 96) };
  }

  function hideVectorStage() {
    if (!refs.vectorStage) return;
    refs.vectorStage.classList.remove('is-visible');
    refs.vectorStage.hidden = true;
    refs.vectorStage.setAttribute('aria-hidden', 'true');
    refs.vectorStage.innerHTML = '';
    delete refs.vectorStage.dataset.svgHash;
  }

  function clearVector() {
    vectorPdfEpoch += 1;
    pendingVectorPdf = null;
    state.vectorSvg = '';
    state.vectorMeta = null;
    state.vectorPdfBlob = null;
    state.vectorExportReady = false;
    state.vectorSourceBlob = null;
    if (state.vectorObjectUrl) URL.revokeObjectURL(state.vectorObjectUrl);
    state.vectorObjectUrl = '';
    if (refs.vectorStatus) refs.vectorStatus.textContent = 'IA';
    if (refs.vectorPreview) refs.vectorPreview.innerHTML = '<span>Aucun résultat</span>';
    hideVectorStage();
  }

  function onCanvasPointerDown(event) {
    if (!hasImage()) return;
    if (!state.crop) {
      state.pan = {
        x: event.clientX,
        y: event.clientY,
        scrollLeft: refs.canvasZone.scrollLeft,
        scrollTop: refs.canvasZone.scrollTop,
      };
      refs.canvasZone.classList.add('is-panning');
      event.currentTarget.setPointerCapture?.(event.pointerId);
      event.preventDefault();
      return;
    }
    const point = eventPointToCanvas(event);
    const handle = cropHitTest(point);
    if (!handle) return;
    event.currentTarget.setPointerCapture?.(event.pointerId);
    state.drag = {
      handle,
      start: point,
      rect: { ...state.crop.rect },
    };
    event.preventDefault();
  }

  function onCanvasPointerMove(event) {
    if (state.pan) {
      refs.canvasZone.scrollLeft = state.pan.scrollLeft - (event.clientX - state.pan.x);
      refs.canvasZone.scrollTop = state.pan.scrollTop - (event.clientY - state.pan.y);
      return;
    }
    if (!state.drag || !state.crop) return;
    const point = eventPointToCanvas(event);
    const dx = point.x - state.drag.start.x;
    const dy = point.y - state.drag.start.y;
    state.crop.rect = resizeCropRect(state.drag.rect, state.drag.handle, dx, dy);
    render();
  }

  function onCanvasPointerUp() {
    state.drag = null;
    state.pan = null;
    refs.canvasZone.classList.remove('is-panning');
  }

  function eventPointToCanvas(event) {
    const stage = currentStageElement() || refs.previewCanvas;
    const rect = stage.getBoundingClientRect();
    return {
      x: clamp((event.clientX - rect.left) * (workCanvas.width / rect.width), 0, workCanvas.width),
      y: clamp((event.clientY - rect.top) * (workCanvas.height / rect.height), 0, workCanvas.height),
    };
  }

  function cropHitTest(point) {
    const rect = state.crop.rect;
    const hs = getHandleSize() * 1.7;
    const handles = cropHandles(rect);
    for (const handle of handles) {
      if (Math.abs(point.x - handle.x) <= hs && Math.abs(point.y - handle.y) <= hs) return handle.name;
    }
    if (point.x >= rect.x && point.x <= rect.x + rect.w && point.y >= rect.y && point.y <= rect.y + rect.h) return 'move';
    return null;
  }

  function cropHandles(rect) {
    const x1 = rect.x;
    const y1 = rect.y;
    const x2 = rect.x + rect.w;
    const y2 = rect.y + rect.h;
    const xm = rect.x + rect.w / 2;
    const ym = rect.y + rect.h / 2;
    return [
      { name: 'nw', x: x1, y: y1 },
      { name: 'n', x: xm, y: y1 },
      { name: 'ne', x: x2, y: y1 },
      { name: 'e', x: x2, y: ym },
      { name: 'se', x: x2, y: y2 },
      { name: 's', x: xm, y: y2 },
      { name: 'sw', x: x1, y: y2 },
      { name: 'w', x: x1, y: ym },
    ];
  }

  function resizeCropRect(original, handle, dx, dy) {
    let x1 = original.x;
    let y1 = original.y;
    let x2 = original.x + original.w;
    let y2 = original.y + original.h;

    if (handle === 'move') {
      const x = clamp(original.x + dx, 0, workCanvas.width - original.w);
      const y = clamp(original.y + dy, 0, workCanvas.height - original.h);
      return { x, y, w: original.w, h: original.h };
    }

    if (handle.includes('w')) x1 += dx;
    if (handle.includes('e')) x2 += dx;
    if (handle.includes('n')) y1 += dy;
    if (handle.includes('s')) y2 += dy;

    x1 = clamp(x1, 0, workCanvas.width - 4);
    y1 = clamp(y1, 0, workCanvas.height - 4);
    x2 = clamp(x2, x1 + 4, workCanvas.width);
    y2 = clamp(y2, y1 + 4, workCanvas.height);
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
  }

  function getHandleSize() {
    return clamp(10 / state.zoom, 5, 24);
  }

  function getContentBounds() {
    const imageData = workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height);
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    const bg = edgeAverageColor(data, w, h);
    const hasAlpha = hasTransparentPixels(imageData);
    const tolerance = Number(refs.bgTolerance && refs.bgTolerance.value) || 44;
    let minX = w;
    let minY = h;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < h; y += 1) {
      for (let x = 0; x < w; x += 1) {
        const idx = (y * w + x) * 4;
        const alpha = data[idx + 3];
        const visible = hasAlpha ? alpha > 10 : alpha > 10 && colorDistanceAt(data, idx, bg) > tolerance;
        if (!visible) continue;
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }

    if (maxX < minX || maxY < minY) return null;
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }

  function edgeAverageColor(data, width, height) {
    const samples = [];
    const add = (x, y) => {
      const idx = (y * width + x) * 4;
      if (data[idx + 3] < 8) return;
      samples.push([data[idx], data[idx + 1], data[idx + 2]]);
    };
    const maxSamples = 60;
    for (let i = 0; i < maxSamples; i += 1) {
      const x = Math.round((width - 1) * (i / (maxSamples - 1)));
      const y = Math.round((height - 1) * (i / (maxSamples - 1)));
      add(x, 0);
      add(x, height - 1);
      add(0, y);
      add(width - 1, y);
    }
    if (!samples.length) return [255, 255, 255];
    const sum = samples.reduce((acc, item) => [acc[0] + item[0], acc[1] + item[1], acc[2] + item[2]], [0, 0, 0]);
    return sum.map((value) => Math.round(value / samples.length));
  }

  function hasTransparentPixels(imageData = null) {
    if (!hasImage() && !imageData) return false;
    const data = imageData ? imageData.data : workCtx.getImageData(0, 0, workCanvas.width, workCanvas.height).data;
    const total = data.length / 4;
    const step = Math.max(1, Math.floor(total / 12000));
    for (let p = 0; p < total; p += step) {
      if (data[p * 4 + 3] < 245) return true;
    }
    return false;
  }

  function expandRect(rect, padding, maxW, maxH) {
    const x = Math.max(0, rect.x - padding);
    const y = Math.max(0, rect.y - padding);
    const x2 = Math.min(maxW, rect.x + rect.w + padding);
    const y2 = Math.min(maxH, rect.y + rect.h + padding);
    return { x, y, w: x2 - x, h: y2 - y };
  }

  function roundedRect(ctx, x, y, w, h, r) {
    const radius = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + w - radius, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
    ctx.lineTo(x + w, y + h - radius);
    ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
    ctx.lineTo(x + radius, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  }

  function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('Lecture du fichier impossible'));
      reader.readAsDataURL(file);
    });
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Image illisible'));
      image.src = src;
    });
  }

  function canvasToBlob(canvas, type) {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Export impossible'));
      }, type);
    });
  }

  function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    window.setTimeout(() => {
      link.remove();
      URL.revokeObjectURL(url);
    }, 1400);
  }

  // Le solde est deja decremente en place : recharger la page fermerait l'editeur
  // (et la modale sur la fiche produit) juste apres le telechargement.
  function syncCreditsAfterDownload() {
    if (!creditConfig.required) return;
    void refreshCredits();
  }

  function hasFreeDownloadAvailable() {
    return (
      creditConfig.freeDownloadEnabled &&
      creditConfig.isLoggedIn &&
      Boolean(creditConfig.customerId) &&
      !state.freeDownloadUsed
    );
  }

  function readFreeDownloadUsed() {
    if (!creditConfig.freeDownloadEnabled || !creditConfig.customerId) return false;
    if (creditConfig.freeDownloadUsed) return true;
    try {
      return window.localStorage.getItem(freeDownloadStorageKey()) === 'true';
    } catch (error) {
      return false;
    }
  }

  function markFreeDownloadUsed() {
    state.freeDownloadUsed = true;
    root.dataset.freeDownloadUsed = 'true';
    try {
      window.localStorage.setItem(freeDownloadStorageKey(), 'true');
    } catch (error) {
      console.warn('Free download flag failed:', error);
    }
  }

  function freeDownloadStorageKey() {
    return `${creditConfig.freeDownloadStoragePrefix}:${creditConfig.customerId}`;
  }

  function parseCreditBalance(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : null;
    if (typeof value === 'string') {
      const match = value.replace(',', '.').match(/-?\d+(\.\d+)?/);
      if (!match) return null;
      const parsed = Number(match[0]);
      return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : null;
    }
    if (typeof value === 'object') {
      return parseCreditBalance(value.remaining ?? value.balance ?? value.credits ?? value.value ?? value.data);
    }
    return null;
  }

  function parseFlag(value) {
    if (value === true || value === 1) return true;
    if (typeof value !== 'string') return false;
    return ['true', '1', 'yes', 'oui'].includes(value.trim().toLowerCase());
  }

  function baseName() {
    const clean = (state.fileName || 'logo')
      .replace(/\.[^.]+$/, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9_-]+/gi, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase();
    return clean || 'logo';
  }

  function pxToCmNumber(px) {
    return (px / DPI) * CM_PER_INCH;
  }

  function setPrintSize(widthCm, heightCm) {
    state.printWidthCm = Math.max(0.1, Number(widthCm) || pxToCmNumber(workCanvas.width));
    state.printHeightCm = Math.max(0.1, Number(heightCm) || pxToCmNumber(workCanvas.height));
    state.qualityCache = null;
  }

  function setPrintSizeFromPixels() {
    state.printWidthCm = hasImage() ? pxToCmNumber(workCanvas.width) : 0;
    state.printHeightCm = hasImage() ? pxToCmNumber(workCanvas.height) : 0;
  }

  function ensurePrintSize() {
    if (!hasImage()) {
      state.printWidthCm = 0;
      state.printHeightCm = 0;
      return;
    }
    if (!(state.printWidthCm > 0)) state.printWidthCm = pxToCmNumber(workCanvas.width);
    if (!(state.printHeightCm > 0)) state.printHeightCm = pxToCmNumber(workCanvas.height);
  }

  function getPrintWidthCm() {
    return state.printWidthCm > 0 ? state.printWidthCm : pxToCmNumber(workCanvas.width);
  }

  function getPrintHeightCm() {
    return state.printHeightCm > 0 ? state.printHeightCm : pxToCmNumber(workCanvas.height);
  }

  function getEffectiveDpi() {
    if (!hasImage()) return 0;
    const widthInches = getPrintWidthCm() / CM_PER_INCH;
    const heightInches = getPrintHeightCm() / CM_PER_INCH;
    const widthDpi = widthInches > 0 ? workCanvas.width / widthInches : 0;
    const heightDpi = heightInches > 0 ? workCanvas.height / heightInches : 0;
    const dpi = Math.min(widthDpi || heightDpi, heightDpi || widthDpi);
    return Math.max(1, Math.round(dpi));
  }

  function getPrintPagePoints() {
    return {
      widthPt: cmToPt(getPrintWidthCm()),
      heightPt: cmToPt(getPrintHeightCm()),
    };
  }

  function cmToPt(cm) {
    return Math.max(1, (cm / CM_PER_INCH) * 72);
  }

  function formatPrintSize(widthCm, heightCm) {
    return `${formatCmInput(widthCm)} x ${formatCmInput(heightCm)} cm`;
  }

  function formatCmInput(value) {
    const next = Number(value);
    if (!Number.isFinite(next)) return '0.1';
    return (Math.round(next * 10) / 10).toFixed(1);
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatRatioPercent(ratio) {
    const percent = ratio * 100;
    if (!Number.isFinite(percent) || percent <= 0) return '0%';
    if (percent < 0.1) return '< 0,1%';
    const rounded = percent >= 10 ? Math.round(percent) : Math.round(percent * 10) / 10;
    return `${String(rounded).replace('.', ',')}%`;
  }

  function toPositiveInt(value, fallback) {
    const next = Math.round(Number(value));
    return Number.isFinite(next) && next > 0 ? next : fallback;
  }

  function toPositiveNumber(value, fallback) {
    const next = Number(value);
    return Number.isFinite(next) && next > 0 ? next : fallback;
  }

  function colorDistanceAt(data, idx, color) {
    const dr = data[idx] - color[0];
    const dg = data[idx + 1] - color[1];
    const db = data[idx + 2] - color[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  function colorDistance(a, b) {
    const dr = a[0] - b[0];
    const dg = a[1] - b[1];
    const db = a[2] - b[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  function rgbToHex(color) {
    return `#${color.map((value) => clamp(Math.round(value), 0, 255).toString(16).padStart(2, '0')).join('')}`;
  }

  function hexToRgb(hex) {
    const clean = hex.replace('#', '').trim();
    const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
    return [
      parseInt(full.slice(0, 2), 16) || 0,
      parseInt(full.slice(2, 4), 16) || 0,
      parseInt(full.slice(4, 6), 16) || 0,
    ];
  }

  function escapeXml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function nextFrame() {
    return new Promise((resolve) => window.requestAnimationFrame(resolve));
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function showToast(message, tone = '') {
    const toast = document.createElement('div');
    toast.className = `le-toast${tone === 'error' ? ' is-error' : ''}${tone === 'good' ? ' is-good' : ''}`;
    toast.textContent = message;
    refs.toastLayer.appendChild(toast);
    window.setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(6px)';
    }, 2600);
    window.setTimeout(() => toast.remove(), 3100);
  }
  }
})();